import { updateButtonBasic, updateButtonInner } from '../ui-modules/button-primary/extract-update';

import { updateContainerFuild } from './container-fuild';

export const updateHtmlFromData = {
  sectionBannerSlider(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const elTitle = container.querySelector('[data-attribute="section-title"]');
          if (elTitle) {
            elTitle.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'container-page': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key]);
            if (updatedData[key]) {
              elContainerPage.classList.add('container');
            } else {
              elContainerPage.classList.remove('container');
            }
          }
          break;
        }
        case 'list-item': {
          const elListItem = container.querySelector('[data-attribute="list-item"]');
          if (elListItem) {
            elListItem.innerHTML = updatedData[key]
              .map(item => {
                return `
                  <div data-attribute="item" class="swiper-slide">
                        <div data-attribute="wrap-content" class="wrap-ct">
                            <div class="wrap-img">
                                <img data-attribute="image-banner" src="${item.image}" alt="">
                            </div>
                            <div class="wrap-text-btn">
                                <div data-show-text="${
                                  item.textBanner.showText
                                }" data-attribute="text-banner" class="wrap-text"
                                    style="display: ${item.textBanner.showText ? 'block' : 'none'};">
                                    ${item.textBanner.text}
                                </div>
                                <div data-show-button="${
                                  item.button.showBtn
                                }" data-attribute="button-banner" class="wrap-btn"
                                    style="display: ${item.button.showBtn ? 'block' : 'none'};">
                                    <a data-background="${item.button.background}" data-color="${
                  item.button.color
                }" style="background-color: ${item.button.background}; color: ${
                  item.button.color
                };" data-attribute="button-link" class="btn-slide" href="${item.button.link}">${item.button.text}</a>
                                </div>
                            </div>
                            <div data-show-overlay="${item.overlay.showOverlay}" data-opacity="${
                  item.overlay.opacity
                }" data-attribute="overlay-slide" class="slide-overlay"
                                style="background-color: black; opacity: ${item.overlay.opacity}; display: ${
                  item.overlay.showOverlay ? 'block' : 'none'
                };"></div>
                        </div>
                    </div>
                `;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionBannerHsia(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const elTitle = container.querySelector('[data-attribute="section-title"]');
          if (elTitle) {
            elTitle.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'styleSection': {
          const cardContainer = container.querySelector('[data-attribute="card-container"]');
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]['topPadding'] ? 'true' : 'false');
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]['bottomPadding'] ? 'true' : 'false');
            cardContainer.setAttribute('data-background', updatedData[key]['background']);
            cardContainer.setAttribute('data-text-color', updatedData[key]['textColor']);
            cardContainer.style.backgroundColor = updatedData[key]['background'];
            cardContainer.style.color = updatedData[key]['textColor'];
            cardContainer.style.setProperty('--text-color', updatedData[key]['textColor']);
          }
          break;
        }
        case 'containerPage': {
          const containerPage = container.querySelector('[data-attribute="container-page"]');
          if (containerPage) {
            containerPage.setAttribute('data-enable-style', updatedData[key]['enableStyle'] ? 'true' : 'false');
            containerPage.setAttribute('data-background-container', updatedData[key]['background']);
            containerPage.style.backgroundColor = updatedData[key]['enableStyle']
              ? updatedData[key]['background']
              : 'transparent';
          }
          break;
        }
        case 'list-item': {
          const elListItem = container.querySelector('[data-attribute="list-item"]');
          if (elListItem) {
            elListItem.innerHTML = (updatedData[key] || [])
              .map(item => {
                return `
                  <div data-attribute="item" class="swiper-slide">
                    <a data-use-mobile="${item.useMobile}" data-attribute="link-item" href="${item.link ||
                  '#'}" class="wrap-item">
                      <div class="wrap-img">
                        <img class="img-desktop" data-attribute="image-banner" src="${item.image || ''}" alt="">
                        ${
                          item.useMobile
                            ? `<img class="img-mobile" data-attribute="image-banner-mobile" src="${item.imageMobile ||
                                ''}" alt="">`
                            : ''
                        }
                      </div>
                    </a>
                  </div>
                `;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardSona(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'text-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.style.color = updatedData[key];
            containerEl.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'button-text-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.setAttribute('data-button-text-color', updatedData[key]);
            containerEl.style.setProperty('--button-text-color', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'card-item-image': {
          const el = container.querySelector('[data-attribute="card-item-image"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-item-content': {
          const el = container.querySelector('[data-attribute="card-item-content"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'style-center-y': {
          const el = container.querySelector('[data-attribute="card-item-content"]');
          if (el) {
            el.setAttribute('data-style-center-y', updatedData[key]);
          }
          break;
        }
        case 'card-image': {
          const el = container.querySelector('[data-attribute="card-image"]');
          if (el) {
            el.setAttribute('src', updatedData[key]);
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-description': {
          const el = container.querySelector('[data-attribute="card-description"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'buttonCard': {
          const elRowBtn = container.querySelector('[data-attribute="card-btn-row"]');
          if (elRowBtn) {
            elRowBtn.setAttribute('data-show-btn', updatedData[key].show);
            elRowBtn.style.display = updatedData[key].show ? 'block' : 'none';
          }
          const elBtn = container.querySelector('[data-attribute="card-btn"]');
          if (elBtn) {
            elBtn.setAttribute('data-background', updatedData[key].background);
            elBtn.setAttribute('data-radius', updatedData[key].radius);
            elBtn.setAttribute('data-color', updatedData[key].color);
            elBtn.style.backgroundColor = updatedData[key].background;
            elBtn.style.color = updatedData[key].color;
            elBtn.style.borderRadius = updatedData[key].radius + 'px';
            elBtn.textContent = updatedData[key].text;
            elBtn.setAttribute('href', updatedData[key].link);
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCustomizeCard(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'card-item-content': {
          const el = container.querySelector(`[data-attribute="card-item-content"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-item-image': {
          const el = container.querySelector(`[data-attribute="card-item-image"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-btn-row': {
          const el = container.querySelector(`[data-attribute="card-btn-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-btn', updatedData[key]);
          }
          break;
        }
        case 'card-rated-row': {
          const el = container.querySelector(`[data-attribute="card-rated-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-rating', updatedData[key]);
          }
          break;
        }
        case 'card-btn': {
          const el = container.querySelector(`[data-attribute="card-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key].text || '');
            el.setAttribute('href', updatedData[key].url);
            if (updatedData[key].background) {
              el.style.backgroundColor = updatedData[key].background;
              el.setAttribute('data-background', updatedData[key].background);
            }
            if (updatedData[key].color) {
              el.style.color = updatedData[key].color;
              el.setAttribute('data-color', updatedData[key].color);
            }
          }
          break;
        }
        // case 'card-content': {
        //   const el = container.querySelector(`[data-attribute="card-content"]`)
        //   if (el) {
        //     el.innerHTML = updatedData[key]
        //   }
        //   break
        // }
        case 'card-image': {
          const el = container.querySelector(`[data-attribute="card-image"]`);
          if (el) {
            el.setAttribute('src', updatedData[key]);
          }
          break;
        }
        case 'sub-btn': {
          const el = container.querySelector(`[data-attribute="sub-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key] || '');
          }
          break;
        }
        case 'rating-stars': {
          const el = container.querySelector(`[data-attribute="rating-stars"]`);
          if (el) {
            el.setAttribute('data-value', updatedData[key]);
          }
          break;
        }
        case 'rating-text': {
          const el = container.querySelector(`[data-attribute="rating-text"]`);
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-description': {
          const el = container.querySelector('[data-attribute="card-description"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-survay': {
          const el = container.querySelector('[data-attribute="card-survay"]');
          // const showSurvay = container.getAttribute('data-show-survay')
          if (el) {
            el.setAttribute('data-show-survay', updatedData[key]);
            el.style.display = updatedData[key] ? 'block' : 'none';
          }
          break;
        }
        case 'items-survay': {
          const itemsSurvay = updatedData[key];
          const wrapSurvay = container.querySelector('[data-attribute="card-survay"]');
          if (wrapSurvay) {
            wrapSurvay.innerHTML = itemsSurvay
              .map(item => {
                const radius = 40;
                const circumference = 2 * Math.PI * radius;
                const offset = circumference * (1 - item.percent / 100);
                return `
                <div data-attribute="item-survay" class="wrap-survay-item">
                    <div class="left-item" style="color: #d1d5db;">
                        <svg class="size-full" viewBox="0 0 100 100">
                            <circle class="text-gray-300" stroke-width="8" stroke="currentColor" fill="transparent" cx="50" cy="50" r="40"></circle>
                            <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8" fill="transparent" stroke="black" stroke-linecap="butt" transform="rotate(-90 50 50)" stroke-dasharray="${circumference}" stroke-dashoffset="${offset}" />
                        </svg>
                        <div class="wrap-percent"><span data-attribute="percent-survay">${item.percent}</span>%</div>
                    </div>
                    <div data-attribute="description-survay" class="right-item">
                        ${item.description}
                    </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'container-page': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            el.setAttribute('data-show-style', updatedData[key]['show-style']);
            el.setAttribute('data-background', updatedData[key]['background']);
            el.style.backgroundColor = updatedData[key]['show-style'] ? updatedData[key]['background'] : 'transparent';
          }
          break;
        }
        case 'style-center-y': {
          const elCardContent = container.querySelector('[data-attribute="card-item-content"]');

          if (elCardContent) {
            elCardContent.setAttribute('data-style-center-y', updatedData[key]);
          }
          break;
        }
        case 'text-color': {
          const cardContent = container.querySelector('[data-attribute="card-content"]');
          const cardTitle = container.querySelector('[data-attribute="card-title"]');
          const cardDescription = container.querySelector('[data-attribute="card-description"]');
          const ratingText = container.querySelectorAll('[data-attribute="rating-text"]');
          const subBtn = container.querySelectorAll('[data-attribute="sub-btn"]');

          if (cardContent) {
            cardContent.style.color = updatedData[key];
            cardContent.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardTitle) {
            cardTitle.style.color = updatedData[key];
            cardTitle.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardDescription) {
            cardDescription.style.color = updatedData[key];
            cardDescription.setAttribute('data-text-color', updatedData[key]);
          }
          if (ratingText) {
            ratingText.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          if (subBtn) {
            subBtn.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardCigar(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'card-item-content': {
          const el = container.querySelector(`[data-attribute="card-item-content"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-item-image': {
          const el = container.querySelector(`[data-attribute="card-item-image"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-btn-row': {
          const el = container.querySelector(`[data-attribute="card-btn-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-btn', updatedData[key]);
          }
          break;
        }
        case 'card-rated-row': {
          const el = container.querySelector(`[data-attribute="card-rated-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-rating', updatedData[key]);
          }
          break;
        }
        case 'card-btn': {
          const el = container.querySelector(`[data-attribute="card-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key].text || '');
            el.setAttribute('href', updatedData[key].url);
            if (updatedData[key].background) {
              el.style.backgroundColor = updatedData[key].background;
              el.setAttribute('data-background', updatedData[key].background);
            }
            if (updatedData[key].color) {
              el.style.color = updatedData[key].color;
              el.setAttribute('data-color', updatedData[key].color);
            }
            if (updatedData[key].radius) {
              el.style.borderRadius = updatedData[key].radius + 'px';
              el.setAttribute('data-radius', updatedData[key].radius);
            }
          }
          break;
        }
        // case 'card-content': {
        //   const el = container.querySelector(`[data-attribute="card-content"]`)
        //   if (el) {
        //     el.innerHTML = updatedData[key]
        //   }
        //   break
        // }
        case 'wrap-img-radius': {
          const el = container.querySelector(`[data-attribute="wrap-img"]`);
          if (el) {
            el.setAttribute('data-radius', updatedData[key]);
            el.style.borderRadius = updatedData[key] + 'px';
          }
          break;
        }
        case 'card-image': {
          const el = container.querySelector(`[data-attribute="card-image"]`);
          if (el) {
            el.setAttribute('src', updatedData[key]);
          }
          break;
        }
        case 'sub-btn': {
          const el = container.querySelector(`[data-attribute="sub-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key] || '');
          }
          break;
        }
        case 'rating-stars': {
          const el = container.querySelector(`[data-attribute="rating-stars"]`);
          if (el) {
            el.setAttribute('data-value', updatedData[key]);
          }
          break;
        }
        case 'rating-text': {
          const el = container.querySelector(`[data-attribute="rating-text"]`);
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-description': {
          const el = container.querySelector('[data-attribute="card-description"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-survay': {
          const el = container.querySelector('[data-attribute="card-survay"]');
          // const showSurvay = container.getAttribute('data-show-survay')
          if (el) {
            el.setAttribute('data-show-survay', updatedData[key]);
            el.style.display = updatedData[key] ? 'block' : 'none';
          }
          break;
        }
        case 'items-survay': {
          const itemsSurvay = updatedData[key];
          const wrapSurvay = container.querySelector('[data-attribute="card-survay"]');
          if (wrapSurvay) {
            wrapSurvay.innerHTML = itemsSurvay
              .map(item => {
                const radius = 40;
                const circumference = 2 * Math.PI * radius;
                const offset = circumference * (1 - item.percent / 100);
                return `
                <div data-attribute="item-survay" class="wrap-survay-item">
                    <div class="left-item" style="color: #d1d5db;">
                        <svg class="size-full" viewBox="0 0 100 100">
                            <circle class="text-gray-300" stroke-width="8" stroke="currentColor" fill="transparent" cx="50" cy="50" r="40"></circle>
                            <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8" fill="transparent" stroke="black" stroke-linecap="butt" transform="rotate(-90 50 50)" stroke-dasharray="${circumference}" stroke-dashoffset="${offset}" />
                        </svg>
                        <div class="wrap-percent"><span data-attribute="percent-survay">${item.percent}</span>%</div>
                    </div>
                    <div data-attribute="description-survay" class="right-item">
                        ${item.description}
                    </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'container-page': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            el.setAttribute('data-show-style', updatedData[key]['show-style']);
            el.setAttribute('data-background', updatedData[key]['background']);
            el.style.backgroundColor = updatedData[key]['show-style'] ? updatedData[key]['background'] : 'transparent';
          }
          break;
        }
        case 'style-center-y': {
          const elCardContent = container.querySelector('[data-attribute="card-item-content"]');

          if (elCardContent) {
            elCardContent.setAttribute('data-style-center-y', updatedData[key]);
          }
          break;
        }
        case 'text-color': {
          const cardContent = container.querySelector('[data-attribute="card-content"]');
          const cardTitle = container.querySelector('[data-attribute="card-title"]');
          const cardDescription = container.querySelector('[data-attribute="card-description"]');
          const ratingText = container.querySelectorAll('[data-attribute="rating-text"]');
          const subBtn = container.querySelectorAll('[data-attribute="sub-btn"]');

          if (cardContent) {
            cardContent.style.color = updatedData[key];
            cardContent.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardTitle) {
            cardTitle.style.color = updatedData[key];
            cardTitle.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardDescription) {
            cardDescription.style.color = updatedData[key];
            cardDescription.setAttribute('data-text-color', updatedData[key]);
          }
          if (ratingText) {
            ratingText.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          if (subBtn) {
            subBtn.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardKynorelle(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'top-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottom-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'container-page': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            const showStyle = !!updatedData[key]?.['show-style'];
            const background = updatedData[key]?.background || '#FFFFFF';
            el.setAttribute('data-show-style', showStyle ? 'true' : 'false');
            el.setAttribute('data-background', background);
            el.style.backgroundColor = showStyle ? background : 'transparent';
          }
          break;
        }
        case 'card-item-content': {
          const el = container.querySelector('[data-attribute="card-item-content"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-item-image': {
          const el = container.querySelector('[data-attribute="card-item-image"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'style-center-y': {
          const el = container.querySelector('[data-attribute="card-item-content"]');
          if (el) {
            el.setAttribute('data-style-center-y', updatedData[key] ? 'true' : 'false');
          }
          break;
        }
        case 'card-title': {
          const contentCard = container.querySelector('[data-attribute="content-card"]');
          if (contentCard) {
            contentCard.innerHTML = updatedData[key] || '';
          }
          break;
        }

        case 'highlight-text': {
          const el = container.querySelector('[data-attribute="highlight-text"]');
          if (el) {
            const showValue = !!updatedData[key]?.show;
            el.setAttribute('data-show', showValue ? 'true' : 'false');
            el.style.display = showValue ? 'block' : 'none';
            el.textContent = updatedData[key]?.content || '';
          }
          break;
        }
        case 'card-survay': {
          const el = container.querySelector('[data-attribute="card-survay"]');
          if (el) {
            const showValue = !!updatedData[key];
            el.setAttribute('data-show-survay', showValue ? 'true' : 'false');
            el.style.display = showValue ? 'block' : 'none';
          }
          break;
        }
        case 'color-percent-survay': {
          const el = container.querySelector('[data-attribute="card-survay"]');
          if (el) {
            el.setAttribute('data-color-percent', updatedData[key] || '#606F99');
            el.style.setProperty('--color-percent', updatedData[key] || '#606F99');
          }
          break;
        }
        case 'items-survay': {
          const itemsSurvay = updatedData[key] || [];
          const wrapSurvay = container.querySelector('[data-attribute="card-survay"]');
          if (wrapSurvay) {
            const colorPercent = updatedData['color-percent-survay'] || '#606F99';
            wrapSurvay.innerHTML = itemsSurvay
              .map(item => {
                const radius = 40;
                const circumference = 2 * Math.PI * radius;
                const percentRaw = item?.percent;
                const percent = Number.isFinite(Number(percentRaw)) ? Number(percentRaw) : 0;
                const clampedPercent = Math.max(0, Math.min(100, percent));
                const offset = circumference * (1 - clampedPercent / 100);
                return `
                <div data-attribute="item-survay" class="wrap-survay-item">
                  <div class="left-item">
                    <svg class="size-full" viewBox="0 0 100 100">
                      <circle class="text-gray-300" stroke-width="8" stroke="#D4DCEB" fill="transparent" cx="50" cy="50" r="40"></circle>
                      <circle
                        data-attribute="percent-circle-survay"
                        r="${radius}"
                        cx="50"
                        cy="50"
                        stroke-width="8"
                        fill="transparent"
                        stroke="${colorPercent}"
                        stroke-linecap="butt"
                        transform="rotate(-90 50 50)"
                        stroke-dasharray="${circumference}"
                        stroke-dashoffset="${offset}"
                      ></circle>
                    </svg>
                    <div class="wrap-percent" data-attribute="wrap-percent-survay" style="color: ${colorPercent}">
                      <span data-value="${clampedPercent}" data-attribute="percent-survay">${clampedPercent}</span>%
                    </div>
                  </div>
                  <div data-attribute="description-survay" class="right-item">
                    ${item?.description || ''}
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'button': {
          const rowBtn = container.querySelector('[data-attribute="card-btn-row"]');
          if (rowBtn) {
            const showBtn = !!updatedData[key]?.show;
            rowBtn.setAttribute('data-show-btn', showBtn ? 'true' : 'false');
            rowBtn.style.display = showBtn ? 'block' : 'none';
          }
          const btn = container.querySelector('[data-attribute="card-btn"]');
          if (btn) {
            const background = updatedData[key]?.background || '#F35C5C';
            const color = updatedData[key]?.color || '#ffffff';
            const radius = updatedData[key]?.radius || 0;
            btn.setAttribute('href', updatedData[key]?.link || '#');
            btn.setAttribute('data-background', background);
            btn.setAttribute('data-color', color);
            btn.setAttribute('data-radius', String(radius));

            btn.style.borderRadius = `${radius}px`;
            btn.style.setProperty('--background-btn', background);
            btn.style.setProperty('--color-btn', color);
            btn.style.setProperty('--border-radius-btn', `${radius}px`);
            const btnText = btn.querySelector('[data-attribute="btn-text"]');
            if (btnText) {
              btnText.textContent = updatedData[key]?.text || '';
            }
          }
          break;
        }
        case 'sub-btn': {
          const el = container.querySelector('[data-attribute="sub-btn"]');
          if (el) {
            el.textContent = updatedData[key] || '';
          }
          break;
        }
        case 'media': {
          const imageWrap = container.querySelector('[data-attribute="wrap-image"]');
          const videoWrap = container.querySelector('[data-attribute="wrap-video"]');

          if (imageWrap) {
            const showImage = !!updatedData[key]?.['show-image'];
            imageWrap.setAttribute('data-show-image', showImage ? 'true' : 'false');
            imageWrap.style.display = showImage ? 'block' : 'none';
            const img = imageWrap.querySelector('[data-attribute="image"]');
            if (img && updatedData[key]?.image !== undefined && showImage) {
              img.setAttribute('src', updatedData[key].image || '');
            } else {
              img.setAttribute('src', '');
            }
          }

          if (videoWrap) {
            const showVideo = !!updatedData[key]?.['show-video'];
            videoWrap.setAttribute('data-show-video', showVideo ? 'true' : 'false');
            videoWrap.style.display = showVideo ? 'block' : 'none';
            const videoSrc = videoWrap.querySelector('[data-attribute="card-video"]');
            if (videoSrc && updatedData[key]?.video !== undefined && showVideo) {
              videoSrc.setAttribute('src', updatedData[key].video || '');
            } else {
              videoSrc.setAttribute('src', '');
            }
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionCardHsiaCategory(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const escapeAttr = value =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    const escapeHtml = value =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl) {
            sectionEl.setAttribute('data-title', updatedData[key] || '');
          }
          break;
        }
        case 'styleSection': {
          const cardContainer = container.querySelector('[data-attribute="card-container"]');
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]['topPadding'] ? 'true' : 'false');
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]['bottomPadding'] ? 'true' : 'false');
            cardContainer.setAttribute('data-background', updatedData[key]['background']);
            cardContainer.setAttribute('data-text-color', updatedData[key]['textColor']);
            cardContainer.style.backgroundColor = updatedData[key]['background'];
            cardContainer.style.color = updatedData[key]['textColor'];
            cardContainer.style.setProperty('--text-color', updatedData[key]['textColor']);
          }
          break;
        }
        case 'containerPage': {
          const containerPage = container.querySelector('[data-attribute="container-page"]');
          if (containerPage) {
            containerPage.setAttribute('data-enable-style', updatedData[key]['enableStyle'] ? 'true' : 'false');
            containerPage.setAttribute('data-background-container', updatedData[key]['background']);
            containerPage.style.backgroundColor = updatedData[key]['enableStyle']
              ? updatedData[key]['background']
              : 'transparent';
          }
          break;
        }
        case 'card-title': {
          const cardTitle = container.querySelector('[data-attribute="card-title"]');
          const showCardTitle = !!updatedData['show-card-title'];
          if (cardTitle) {
            cardTitle.innerHTML = showCardTitle ? updatedData[key] || '' : '';
            cardTitle.setAttribute('data-show', showCardTitle ? 'true' : 'false');
            cardTitle.style.display = showCardTitle ? 'block' : 'none';
          }
          break;
        }

        case 'colPerView': {
          const listItem = container.querySelector('[data-attribute="list-item"]');
          if (listItem) {
            const colPerView = Number(updatedData[key]) > 0 ? Number(updatedData[key]) : 1;
            listItem.setAttribute('data-colperview', String(colPerView));
            listItem.style.setProperty('--col-perview', String(colPerView));
          }
          break;
        }
        case 'categories': {
          const listItem = container.querySelector('[data-attribute="list-item"]');
          if (listItem) {
            const items = (Array.isArray(updatedData[key]) ? updatedData[key] : []).filter(Boolean);
            listItem.innerHTML = items
              .map(item => {
                const title = escapeHtml(item?.title || '');
                const image = escapeAttr(item?.image || '');
                const link = escapeAttr(item?.link || '#');
                return `<a data-attribute="item-category" href="${link}" class="item-category">
        <div class="item-category-image">
          <img data-attribute="image-category" src="${image}" alt="" />
        </div>
        <div data-attribute="title-category" class="item-category-name">
          <h3>${title}</h3>
        </div>
      </a>`;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionCardHsiaGrid(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const escapeAttr = value =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl) {
            sectionEl.setAttribute('data-title', updatedData[key] || '');
          }
          break;
        }
        case 'styleSection': {
          const cardContainer = container.querySelector('[data-attribute="card-container"]');
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]['topPadding'] ? 'true' : 'false');
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]['bottomPadding'] ? 'true' : 'false');
            cardContainer.setAttribute('data-background', updatedData[key]['background']);
            cardContainer.setAttribute('data-text-color', updatedData[key]['textColor']);
            cardContainer.style.backgroundColor = updatedData[key]['background'];
            cardContainer.style.color = updatedData[key]['textColor'];
            cardContainer.style.setProperty('--text-color', updatedData[key]['textColor']);
          }
          break;
        }
        case 'containerPage': {
          const containerPage = container.querySelector('[data-attribute="container-page"]');
          if (containerPage) {
            containerPage.setAttribute('data-enable-style', updatedData[key]['enableStyle'] ? 'true' : 'false');
            containerPage.setAttribute('data-background-container', updatedData[key]['background']);
            containerPage.style.backgroundColor = updatedData[key]['enableStyle']
              ? updatedData[key]['background']
              : 'transparent';
          }
          break;
        }
        case 'card-title': {
          const cardTitle = container.querySelector('[data-attribute="card-title"]');
          const showCardTitle = !!updatedData['show-card-title'];
          if (cardTitle) {
            cardTitle.innerHTML = showCardTitle ? updatedData[key] || '' : '';
            cardTitle.setAttribute('data-show', showCardTitle ? 'true' : 'false');
            cardTitle.style.display = showCardTitle ? 'block' : 'none';
          }
          break;
        }
        case 'items': {
          const listItem = container.querySelector('[data-attribute="list-item"]');
          if (listItem) {
            const items = (Array.isArray(updatedData[key]) ? updatedData[key] : []).filter(Boolean);
            listItem.innerHTML = items
              .map(item => {
                const image = escapeAttr(item?.image || '');
                const link = escapeAttr(item?.link || '#');
                return `<a href="${link}" data-attribute="item" class="item">
      <div class="wrap-img">
        <img data-attribute="image-item" src="${image}" alt="" />
      </div>
    </a>`;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionCardReviewHsiaGrid(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const escapeAttr = value =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    const renderStars = value => {
      const count = Number.isFinite(Number(value)) ? Math.max(0, Math.min(5, Number(value))) : 5;
      return Array.from({ length: count })
        .map(
          () => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>star</title>
          <path
            d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
            fill="currentColor"
          />
        </svg>`,
        )
        .join('');
    };

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl) {
            sectionEl.setAttribute('data-title', updatedData[key] || '');
          }
          break;
        }
        case 'styleSection': {
          const cardContainer = container.querySelector('[data-attribute="card-container"]');
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]['topPadding'] ? 'true' : 'false');
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]['bottomPadding'] ? 'true' : 'false');
            cardContainer.setAttribute('data-background', updatedData[key]['background']);
            cardContainer.setAttribute('data-text-color', updatedData[key]['textColor']);
            cardContainer.style.backgroundColor = updatedData[key]['background'];
            cardContainer.style.color = updatedData[key]['textColor'];
            cardContainer.style.setProperty('--text-color', updatedData[key]['textColor']);
          }
          break;
        }
        case 'containerPage': {
          const containerPage = container.querySelector('[data-attribute="container-page"]');
          if (containerPage) {
            containerPage.setAttribute('data-enable-style', updatedData[key]['enableStyle'] ? 'true' : 'false');
            containerPage.setAttribute('data-background-container', updatedData[key]['background']);
            containerPage.style.backgroundColor = updatedData[key]['enableStyle']
              ? updatedData[key]['background']
              : 'transparent';
          }
          break;
        }
        case 'card-title': {
          const cardTitle = container.querySelector('[data-attribute="card-title"]');
          const showCardTitle = !!updatedData['show-card-title'];
          if (cardTitle) {
            cardTitle.innerHTML = showCardTitle ? updatedData[key] || '' : '';
            cardTitle.setAttribute('data-show', showCardTitle ? 'true' : 'false');
            cardTitle.style.display = showCardTitle ? 'block' : 'none';
          }
          break;
        }
        case 'show-list-image-review': {
          const listImageReview = container.querySelector('[data-attribute="list-image-review"]');
          if (listImageReview) {
            const show = !!updatedData[key];
            listImageReview.setAttribute('data-show', show ? 'true' : 'false');
            listImageReview.style.display = show ? '' : 'none';
          }
          break;
        }
        case 'images': {
          const listImageReview = container.querySelector('[data-attribute="list-image-review"]');
          if (listImageReview) {
            const images = (Array.isArray(updatedData[key]) ? updatedData[key] : []).filter(Boolean);
            listImageReview.innerHTML = images
              .map(image => {
                return `<div class="wrap-img">
      <img data-attribute="image-item-review" src="${escapeAttr(image)}" alt="" />
    </div>`;
              })
              .join('');
          }
          break;
        }
        case 'show-list-review-text': {
          const listReviewText = container.querySelector('[data-attribute="list-review-text"]');
          if (listReviewText) {
            const show = !!updatedData[key];
            listReviewText.setAttribute('data-show', show ? 'true' : 'false');
            listReviewText.style.display = show ? '' : 'none';
          }
          break;
        }
        case 'color-star':
        case 'bg-item-review': {
          const listReviewText = container.querySelector('[data-attribute="list-review-text"]');
          if (listReviewText) {
            const colorStar = updatedData['color-star'] || '#b75d3e';
            const bgItemReview = updatedData['bg-item-review'] || '#f7f7f7';
            listReviewText.setAttribute('data-color-star', colorStar);
            listReviewText.setAttribute('data-bg-item-review', bgItemReview);
            listReviewText.style.setProperty('--color-star', colorStar);
            listReviewText.style.setProperty('--bg-item-review', bgItemReview);
          }
          break;
        }
        case 'reviews': {
          const listReviewText = container.querySelector('[data-attribute="list-review-text"]');
          if (listReviewText) {
            const reviews = (Array.isArray(updatedData[key]) ? updatedData[key] : []).filter(Boolean);
            listReviewText.innerHTML = reviews
              .map(item => {
                const link = escapeAttr(item.link || '#');
                const content = item.content || '';
                const showButton = item['show-button'] !== false;
                const buttonText = escapeAttr(item['button-text'] || 'SHOP THIS ITEM');
                const stars = renderStars(item.stars);
                const starValue = Number.isFinite(Number(item.stars))
                  ? Math.max(0, Math.min(5, Number(item.stars)))
                  : 5;
                return `<a href="${link}" data-attribute="item-review-text" class="wrap-item-review-text">
      <div data-attribute="star-item-review" data-value="${starValue}" class="wrap-star">
        ${stars}
      </div>
      <div>
        <div data-attribute="text-item-review" class="text-review">
          ${content}
        </div>
      </div>
      <div data-show="${
        showButton ? 'true' : 'false'
      }" data-attribute="btn-item-review" class="btn-review-item" style="display: ${showButton ? '' : 'none'};">
        <div data-attribute="btn-item-review-text" class="btn-item-review-text">${buttonText}</div>
        <div data-attribute="icon-item-review" class="icon-bnt-review"></div>
      </div>
    </a>`;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionCardHsiaTags(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const normalizeMediaType = media => (media?.type === 'image' ? 'image' : 'video');

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl) {
            sectionEl.setAttribute('data-title', updatedData[key] || '');
          }
          break;
        }
        case 'styleSection': {
          const cardContainer = container.querySelector('[data-attribute="card-container"]');
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]['topPadding'] ? 'true' : 'false');
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]['bottomPadding'] ? 'true' : 'false');
            cardContainer.setAttribute('data-background', updatedData[key]['background']);
            cardContainer.setAttribute('data-text-color', updatedData[key]['textColor']);
            cardContainer.style.backgroundColor = updatedData[key]['background'];
            cardContainer.style.color = updatedData[key]['textColor'];
            cardContainer.style.setProperty('--text-color', updatedData[key]['textColor']);
          }
          break;
        }
        case 'containerPage': {
          const containerPage = container.querySelector('[data-attribute="container-page"]');
          if (containerPage) {
            containerPage.setAttribute('data-enable-style', updatedData[key]['enableStyle'] ? 'true' : 'false');
            containerPage.setAttribute('data-background-container', updatedData[key]['background']);
            containerPage.style.backgroundColor = updatedData[key]['enableStyle']
              ? updatedData[key]['background']
              : 'transparent';
          }
          break;
        }
        case 'bg-card': {
          const wrapCard = container.querySelector('[data-attribute="wrap-card"]');
          if (wrapCard) {
            wrapCard.setAttribute('data-bg-card', updatedData[key] || '#f5f1ee');
            wrapCard.style.backgroundColor = updatedData[key] || '#f5f1ee';
          }
          break;
        }
        case 'card-left-order': {
          const cardLeft = container.querySelector('[data-attribute="card-left"]');
          const cardRight = container.querySelector('[data-attribute="card-right"]');
          const leftOrder = Number(updatedData[key]) === 2 ? 2 : 1;
          if (cardLeft) {
            cardLeft.setAttribute('data-order', String(leftOrder));
            cardLeft.style.order = String(leftOrder);
          }
          if (cardRight) {
            const rightOrder = leftOrder === 1 ? 2 : 1;
            cardRight.setAttribute('data-order', String(rightOrder));
            cardRight.style.order = String(rightOrder);
          }
          break;
        }
        case 'card-right-order': {
          const cardRight = container.querySelector('[data-attribute="card-right"]');
          const cardLeft = container.querySelector('[data-attribute="card-left"]');
          const rightOrder = Number(updatedData[key]) === 1 ? 1 : 2;
          if (cardRight) {
            cardRight.setAttribute('data-order', String(rightOrder));
            cardRight.style.order = String(rightOrder);
          }
          if (cardLeft) {
            const leftOrder = rightOrder === 1 ? 2 : 1;
            cardLeft.setAttribute('data-order', String(leftOrder));
            cardLeft.style.order = String(leftOrder);
          }
          break;
        }
        case 'card-title': {
          const titleEl = container.querySelector('[data-attribute="card-title"]');
          if (titleEl) {
            titleEl.innerHTML = updatedData[key] || '';
          }
          break;
        }
        case 'tags': {
          const wrapTags = container.querySelector('[data-attribute="list-tags"] .wrap-list-tags');
          if (wrapTags) {
            const items = Array.isArray(updatedData[key]) ? updatedData[key] : [];
            wrapTags.innerHTML = items
              .filter(Boolean)
              .map(item => `<a data-attribute="tag-item" href="${item.link}" class="tag-item">${item.text}</a>`)
              .join('');
          }
          break;
        }
        case 'color-tag-item':
        case 'bg-tag-item':
        case 'color-hover-tag-item':
        case 'bg-hover-tag-item': {
          const listTags = container.querySelector('[data-attribute="list-tags"]');
          if (listTags) {
            const colorTagItem = updatedData['color-tag-item'] || '#ffffff';
            const bgTagItem = updatedData['bg-tag-item'] || '#000000';
            const colorHoverTagItem = updatedData['color-hover-tag-item'] || '#000000';
            const bgHoverTagItem = updatedData['bg-hover-tag-item'] || '#ffffff';
            listTags.setAttribute('data-color-tag-item', colorTagItem);
            listTags.setAttribute('data-bg-tag-item', bgTagItem);
            listTags.setAttribute('data-color-hover-tag-item', colorHoverTagItem);
            listTags.setAttribute('data-bg-hover-tag-item', bgHoverTagItem);
            listTags.style.setProperty('--color-tag-item', colorTagItem);
            listTags.style.setProperty('--bg-tag-item', bgTagItem);
            listTags.style.setProperty('--color-hover-tag-item', colorHoverTagItem);
            listTags.style.setProperty('--bg-hover-tag-item', bgHoverTagItem);
          }
          break;
        }
        case 'media': {
          const type = normalizeMediaType(updatedData[key]);
          const showImage = type === 'image';
          const showVideo = !showImage;

          const videoWrap = container.querySelector('[data-attribute="video-card"]');
          const imageWrap = container.querySelector('[data-attribute="image-card"]');

          if (videoWrap) {
            videoWrap.setAttribute('data-show-video', showVideo ? 'true' : 'false');
            videoWrap.style.display = showVideo ? 'block' : 'none';
            const videoItem = videoWrap.querySelector('[data-attribute="video-item"]');
            if (videoItem && updatedData[key]?.video !== undefined && showVideo) {
              videoItem.setAttribute('src', updatedData[key].video || '');
            } else {
              videoItem.setAttribute('src', '');
            }
          }

          if (imageWrap) {
            imageWrap.setAttribute('data-show-image', showImage ? 'true' : 'false');
            imageWrap.style.display = showImage ? 'block' : 'none';
            const imageItem = imageWrap.querySelector('[data-attribute="image-item"]');
            if (imageItem && updatedData[key]?.image !== undefined && showImage) {
              imageItem.setAttribute('src', updatedData[key].image || '');
            } else {
              imageItem.setAttribute('src', '');
            }
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionCardVideo(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'card-item-content': {
          const el = container.querySelector(`[data-attribute="card-item-content"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-item-image': {
          const el = container.querySelector(`[data-attribute="card-item-image"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-btn-row': {
          const el = container.querySelector(`[data-attribute="card-btn-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-btn', updatedData[key]);
          }
          break;
        }
        case 'card-rated-row': {
          const el = container.querySelector(`[data-attribute="card-rated-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-rating', updatedData[key]);
          }
          break;
        }
        case 'card-btn': {
          const el = container.querySelector(`[data-attribute="card-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key].text || '');
            el.setAttribute('href', updatedData[key].url);
            if (updatedData[key].background) {
              el.style.backgroundColor = updatedData[key].background;
              el.setAttribute('data-background', updatedData[key].background);
            }
            if (updatedData[key].color) {
              el.style.color = updatedData[key].color;
              el.setAttribute('data-color', updatedData[key].color);
            }
            if (updatedData[key].radius) {
              el.style.borderRadius = updatedData[key].radius + 'px';
              el.setAttribute('data-radius', updatedData[key].radius);
            }
          }
          break;
        }
        // case 'card-content': {
        //   const el = container.querySelector(`[data-attribute="card-content"]`)
        //   if (el) {
        //     el.innerHTML = updatedData[key]
        //   }
        //   break
        // }
        case 'wrap-img-radius': {
          const el = container.querySelector(`[data-attribute="wrap-img"]`);
          if (el) {
            el.setAttribute('data-radius', updatedData[key]);
            el.style.borderRadius = updatedData[key] + 'px';
          }
          break;
        }
        case 'card-video': {
          const el = container.querySelector(`[data-attribute="card-video"]`);
          if (el) {
            el.setAttribute('src', updatedData[key]);
          }
          break;
        }
        case 'sub-btn': {
          const el = container.querySelector(`[data-attribute="sub-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key] || '');
          }
          break;
        }
        case 'rating-stars': {
          const el = container.querySelector(`[data-attribute="rating-stars"]`);
          if (el) {
            el.setAttribute('data-value', updatedData[key]);
          }
          break;
        }
        case 'rating-text': {
          const el = container.querySelector(`[data-attribute="rating-text"]`);
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-description': {
          const el = container.querySelector('[data-attribute="card-description"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-survay': {
          const el = container.querySelector('[data-attribute="card-survay"]');
          // const showSurvay = container.getAttribute('data-show-survay')
          if (el) {
            el.setAttribute('data-show-survay', updatedData[key]);
            el.style.display = updatedData[key] ? 'block' : 'none';
          }
          break;
        }
        case 'items-survay': {
          const itemsSurvay = updatedData[key];
          const wrapSurvay = container.querySelector('[data-attribute="card-survay"]');
          if (wrapSurvay) {
            wrapSurvay.innerHTML = itemsSurvay
              .map(item => {
                const radius = 40;
                const circumference = 2 * Math.PI * radius;
                const offset = circumference * (1 - item.percent / 100);
                return `
                <div data-attribute="item-survay" class="wrap-survay-item">
                    <div class="left-item" style="color: #d1d5db;">
                        <svg class="size-full" viewBox="0 0 100 100">
                            <circle class="text-gray-300" stroke-width="8" stroke="currentColor" fill="transparent" cx="50" cy="50" r="40"></circle>
                            <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8" fill="transparent" stroke="black" stroke-linecap="butt" transform="rotate(-90 50 50)" stroke-dasharray="${circumference}" stroke-dashoffset="${offset}" />
                        </svg>
                        <div class="wrap-percent"><span data-attribute="percent-survay">${item.percent}</span>%</div>
                    </div>
                    <div data-attribute="description-survay" class="right-item">
                        ${item.description}
                    </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'container-page': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            el.setAttribute('data-show-style', updatedData[key]['show-style']);
            el.setAttribute('data-background', updatedData[key]['background']);
            el.style.backgroundColor = updatedData[key]['show-style'] ? updatedData[key]['background'] : 'transparent';
          }
          break;
        }
        case 'style-center-y': {
          const elCardContent = container.querySelector('[data-attribute="card-item-content"]');

          if (elCardContent) {
            elCardContent.setAttribute('data-style-center-y', updatedData[key]);
          }
          break;
        }
        case 'text-color': {
          const cardContent = container.querySelector('[data-attribute="card-content"]');
          const cardTitle = container.querySelector('[data-attribute="card-title"]');
          const cardDescription = container.querySelector('[data-attribute="card-description"]');
          const ratingText = container.querySelectorAll('[data-attribute="rating-text"]');
          const subBtn = container.querySelectorAll('[data-attribute="sub-btn"]');

          if (cardContent) {
            cardContent.style.color = updatedData[key];
            cardContent.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardTitle) {
            cardTitle.style.color = updatedData[key];
            cardTitle.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardDescription) {
            cardDescription.style.color = updatedData[key];
            cardDescription.setAttribute('data-text-color', updatedData[key]);
          }
          if (ratingText) {
            ratingText.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          if (subBtn) {
            subBtn.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardFaqKynorelle(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const renderAccordionItems = (items = []) =>
      items
        .map(
          item => `
            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">${item.title || ''}</div>
                <div class="accordion-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down"
                  >
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">
                  ${item.text || ''}
                </div>
              </div>
            </div>
          `,
        )
        .join('');

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'top-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottom-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'container-page': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            el.setAttribute('data-show-style', updatedData[key]['show-style']);
            el.setAttribute('data-background', updatedData[key]['background']);
            el.style.backgroundColor = updatedData[key]['show-style'] ? updatedData[key]['background'] : 'transparent';
          }
          break;
        }
        case 'card-item-image': {
          const imageOrder = Number(updatedData[key]) || 2;
          const contentOrder = imageOrder === 1 ? 2 : 1;
          const elImage = container.querySelector('[data-attribute="card-item-image"]');
          const elContent = container.querySelector('[data-attribute="card-item-content"]');
          if (elImage) {
            elImage.setAttribute('data-order', imageOrder);
            elImage.style.order = imageOrder;
          }
          if (elContent) {
            elContent.setAttribute('data-order', contentOrder);
            elContent.style.order = contentOrder;
          }
          break;
        }
        case 'card-item-content': {
          const contentOrder = Number(updatedData[key]) || 1;
          const imageOrder = contentOrder === 1 ? 2 : 1;
          const elImage = container.querySelector('[data-attribute="card-item-image"]');
          const elContent = container.querySelector('[data-attribute="card-item-content"]');
          if (elContent) {
            elContent.setAttribute('data-order', contentOrder);
            elContent.style.order = contentOrder;
          }
          if (elImage) {
            elImage.setAttribute('data-order', imageOrder);
            elImage.style.order = imageOrder;
          }
          break;
        }
        case 'style-center-y': {
          const el = container.querySelector('[data-attribute="card-item-content"]');
          if (el) {
            el.setAttribute('data-style-center-y', updatedData[key]);
          }
          break;
        }
        case 'content-title': {
          const el = container.querySelector('[data-attribute="content-title"]');
          const showTitle = !!updatedData[key]?.show;
          if (el) {
            el.setAttribute('data-show-title', showTitle ? 'true' : 'false');
            el.style.display = showTitle ? 'block' : 'none';
            el.innerHTML = showTitle ? updatedData[key]?.heading || '' : '';
          }
          break;
        }
        case 'accordions': {
          const el = container.querySelector('[data-attribute="card-accordions"]');
          if (el) {
            const showVal = updatedData[key].show;
            const items = updatedData[key].items || [];
            el.setAttribute('data-show-accordion', showVal);
            el.style.display = showVal ? 'block' : 'none';
            el.innerHTML = renderAccordionItems(items);
          }
          break;
        }
        case 'button': {
          const buttonRow = container.querySelector('[data-attribute="button"]');
          const buttonEl = container.querySelector('[data-attribute="card-btn"]');
          if (buttonRow) {
            buttonRow.setAttribute('data-show-button', updatedData[key].show);
            buttonRow.style.display = updatedData[key].show ? 'block' : 'none';
          }
          if (buttonEl) {
            buttonEl.setAttribute('href', updatedData[key].link || '#');
            buttonEl.setAttribute('data-radius', updatedData[key].radius || '0');
            buttonEl.setAttribute('data-background', updatedData[key].background || '#003568');
            buttonEl.setAttribute('data-color', updatedData[key].color || '#ffffff');
            buttonEl.style.setProperty('--color-btn', updatedData[key].color || '#ffffff');
            buttonEl.style.setProperty('--background-btn', updatedData[key].background || '#003568');
            buttonEl.style.setProperty('--border-radius-btn', `${updatedData[key].radius || '0'}px`);
            buttonEl.style.borderRadius = `${updatedData[key].radius || '0'}px`;

            const buttonText = buttonEl.querySelector('[data-attribute="btn-text"]');
            if (buttonText) {
              buttonText.textContent = updatedData[key].text || '';
            }
          }
          break;
        }
        case 'media': {
          const wrapImage = container.querySelector('[data-attribute="wrap-image"]');
          const wrapVideo = container.querySelector('[data-attribute="wrap-video"]');
          if (wrapImage) {
            wrapImage.setAttribute('data-show-image', updatedData[key]['show-image']);
            wrapImage.style.display = updatedData[key]['show-image'] ? 'block' : 'none';
            const imageEl = wrapImage.querySelector('[data-attribute="image"]');
            if (imageEl) imageEl.setAttribute('src', updatedData[key].image || '');
          }
          if (wrapVideo) {
            wrapVideo.setAttribute('data-show-video', updatedData[key]['show-video']);
            wrapVideo.style.display = updatedData[key]['show-video'] ? 'block' : 'none';
            const videoEl = wrapVideo.querySelector('[data-attribute="card-video"]');
            if (videoEl) videoEl.setAttribute('src', updatedData[key].video || '');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionSliderReviewKynorelle(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const renderStars = value => {
      const stars = Math.min(5, Math.max(0, Number(value) || 0));
      return Array(5)
        .fill(null)
        .map(
          (_, index) => `
            <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                fill="${index < stars ? '#F9AC07' : '#E7E7E7'}"
              />
            </svg>
          `,
        )
        .join('');
    };

    const renderReviewItem = item => `
      <div data-attribute="item-review" class="item-review swiper-slide">
        <div class="content-item">
          <div class="review-image-container">
            <img
              loading="lazy"
              data-attribute="review-image"
              src="${item.image || ''}"
              alt="review image"
              class="review-image"
            />
          </div>
          <div class="review-content">
            <div data-attribute="wrap-stars" class="wrap-stars" data-value="${Number(item.stars) || 5}">
              ${renderStars(item.stars)}
            </div>
            <div class="review-content-text" data-attribute="review-content">
              ${item.content || ''}
            </div>
            <div class="review-name" data-attribute="review-name">${item.name || ''}</div>
            <div class="verified-buyer">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                  fill="#42ADA4"
                />
                <path
                  d="M11.8173 4.56738L6.88729 9.49738L4.85728 7.46738L3.84229 8.48238L6.88729 11.5274L12.8323 5.58238L11.8173 4.56738Z"
                  fill="#E3F2FD"
                />
              </svg>
              <span>verified buyer</span>
            </div>
          </div>
        </div>
      </div>
    `;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'top-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottom-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'container-page': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            el.setAttribute('data-show-style', updatedData[key]['show-style']);
            el.setAttribute('data-background', updatedData[key]['background']);
            el.style.backgroundColor = updatedData[key]['show-style'] ? updatedData[key]['background'] : 'transparent';
          }
          break;
        }
        case 'content-title': {
          const el = container.querySelector('[data-attribute="content-title"]');
          if (el) {
            el.setAttribute('data-show-title', updatedData[key].show);
            el.style.display = updatedData[key].show ? 'block' : 'none';
            if (updatedData[key].show) {
              el.innerHTML = updatedData[key].heading || '';
            }
          }
          break;
        }
        case 'title-card': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            el.setAttribute('data-show', updatedData[key].show);
            el.style.display = updatedData[key].show ? 'block' : 'none';
            if (updatedData[key].show) {
              el.innerHTML = updatedData[key].content || '';
            }
          }
          break;
        }
        case 'col-per-view': {
          const el = container.querySelector('[data-attribute="body-review"]');
          if (el) {
            el.setAttribute('data-col-per-view', Number(updatedData[key]) || 4);
          }
          break;
        }
        case 'reviews': {
          const el = container.querySelector('.review-slider');
          if (el) {
            el.innerHTML = (updatedData[key] || []).map(item => renderReviewItem(item)).join('');
          }
          break;
        }
        case 'button': {
          const buttonRow = container.querySelector('[data-attribute="button"]');
          if (buttonRow) {
            buttonRow.setAttribute('data-show-button', updatedData[key].show);
            buttonRow.style.display = updatedData[key].show ? 'block' : 'none';
          }

          const buttonEl = container.querySelector('[data-attribute="card-btn"]');
          if (buttonEl) {
            const radius = updatedData[key].radius || '4';
            buttonEl.setAttribute('href', updatedData[key].link || '#');
            buttonEl.setAttribute('data-radius', radius);
            buttonEl.setAttribute('data-background', updatedData[key].background || '#003568');
            buttonEl.setAttribute('data-color', updatedData[key].color || '#ffffff');
            buttonEl.style.setProperty('--color-btn', updatedData[key].color || '#ffffff');
            buttonEl.style.setProperty('--background-btn', updatedData[key].background || '#003568');
            buttonEl.style.setProperty('--border-radius-btn', `${radius}px`);
            buttonEl.style.borderRadius = `${radius}px`;

            const textEl = buttonEl.querySelector('[data-attribute="btn-text"]');
            if (textEl) {
              textEl.textContent = updatedData[key].text || 'SHOP NOW';
            }
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardVideoSlider(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'header': {
          const el = container.querySelector('[data-attribute="card-header"]');
          const show = updatedData[key].show;
          if (el) {
            el.innerHTML = updatedData[key].content;
            el.style.display = show ? 'block' : 'none';
            el.setAttribute('data-show', show);
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.innerHTML = updatedData[key]
              .map(item => {
                return `
                <div data-attribute="item" class="swiper-slide">
                  <div class="wrap-item">
                    <video loop playsinline width="600">
                      <source data-attribute="card-video"
                        src="${item.video}"
                        type="video/mp4">
                    </video>
                    <div data-attribute="playvideo" data-background="${updatedData.btnPlayVideo.background}" data-color="${updatedData.btnPlayVideo.color}"
                      style="background-color: ${updatedData.btnPlayVideo.background}; color: ${updatedData.btnPlayVideo.color};" class="playvideo">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-play-icon lucide-play">
                        <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                      </svg>
                    </div>
                    <div class="volume">
                      <span class="volume-icon" style="display: flex;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-volume2-icon lucide-volume-2">
                          <path
                            d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
                          <path d="M16 9a5 5 0 0 1 0 6" />
                          <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                        </svg>
                      </span>
                      <span class="mute-icon" style="display: none;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-volume-off-icon lucide-volume-off">
                          <path d="M16 9a5 5 0 0 1 .95 2.293" />
                          <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                          <path d="m2 2 20 20" />
                          <path
                            d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11" />
                          <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionProductsSlider(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'containerBackground': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'header': {
          const el = container.querySelector('[data-attribute="section-header"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          const { itemCommon } = updatedData;
          const { background, color, radius, saveBg, saveColor, btnBg, btnColor, btnRadius, btnText } = itemCommon;
          if (el) {
            el.innerHTML = updatedData[key]
              .map(item => {
                return `
                  <div data-attribute="item" class="swiper-slide">
                    <a href="${item.link ||
                      '#'}" data-attribute="wrap-item" class="wrap-item" data-bg="${background}" data-color="${color}"
                      data-radius="${radius}" style="background-color: ${background}; color: ${color}; border-radius: ${radius}px;">
                      <div class="wrap-img">
                        <img data-attribute="img-item" loading="lazy" src=${item.image} alt="">
                      </div>
                      <div class="content-item">
                        <div class="wrap-text">
                          <div data-attribute="wrap-rated" data-show-rating="${
                            item.showRating
                          }" class="wrap-rated" style="display: ${item.showRating ? 'flex' : 'none'};">
                            <div data-attribute="rating-stars" data-value="${item.ratingStars}" class="wrap-stars">
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                                <!---->
                                <path
                                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                                </path>
                                <!----><!----><!---->
                              </svg>
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                                <!---->
                                <path
                                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                                </path>
                                <!----><!----><!---->
                              </svg>
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                                <!---->
                                <path
                                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                                </path>
                                <!----><!----><!---->
                              </svg>
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                                <!---->
                                <path
                                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                                </path>
                                <!----><!----><!---->
                              </svg>
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                                <!---->
                                <path
                                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                                </path>
                                <!----><!----><!---->
                              </svg>
                            </div>
                            <div data-attribute="rating-text" class="rating-text">${item.ratingText}</div>
                          </div>
                          <div data-attribute="header-item" class="header-item">
                            ${item.headerItem}
                          </div>
                          <div data-show-price="true" class="wrap-price">
                            <div data-show-new="true" data-value="${
                              item.priceNew
                            }" data-attribute="price-new" class="price-new">$${item.priceNew}</div>
                            <div data-show-old="true" data-value="${
                              item.priceOld
                            }" data-attribute="price-old" class="price-old">$${item.priceOld}</div>
                            <div data-bg="${saveBg}" data-color="${saveColor}" data-show-sale="${
                  item.showSave
                }" data-attribute="price-sale" data-value="${
                  item.priceSale
                }" class="price-sale" style="background-color: ${saveBg}; color: ${saveColor}; display: ${
                  item.showSave ? 'block' : 'none'
                };">${item.priceSale}</div>
                          </div>
                        </div>
                        <div data-radius="${btnRadius}" data-bg="${btnBg}" data-color="${btnColor}" data-attribute="btn-view-more"
                          class="btn-view-more" style="background-color: ${btnBg}; color: ${btnColor}; border-radius: ${btnRadius}px;">
                          ${btnText}
                        </div>
                      </div>
                    </a>
                  </div>
                `;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionBannerKynorelle(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const elTitle = container.querySelector('[data-attribute="section-title"]');
          if (elTitle) {
            elTitle.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'container-page': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            el.setAttribute('data-show-style', updatedData[key]);
            if (updatedData[key]) {
              el.classList.add('container');
            } else {
              el.classList.remove('container');
            }
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'top-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottom-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'list-item': {
          const elList = container.querySelector('[data-attribute="list-item"]');
          if (elList) {
            const renderShowAttr = show => (show ? 'true' : 'false');
            const renderSubtitle = subtitle => {
              if (!subtitle.show) return '';
              return `
                <div data-show="true" data-attribute="block-subtitle" class="block-subtitle">
                  <div class="wrap-icon">
                    <img data-attribute="subtitle-icon" src="${subtitle.icon || ''}" alt="" />
                  </div>
                  <div data-attribute="text-subtitle" class="text-subtitle">${subtitle.text || ''}</div>
                  <div class="wrap-avatars">
                    <img data-attribute="subtitle-avatars" src="${subtitle.avatars || ''}" alt="" />
                  </div>
                </div>
              `;
            };
            const renderTitle = title => {
              if (!title.show) return '';
              const titleContent =
                title.content !== undefined
                  ? title.content
                  : `<h2>${title.heading || ''}</h2><p>${title.tagline || ''}</p>`;
              return `
                <div data-show="true" data-attribute="title-banner-item" class="title-banner-item">
                  ${titleContent}
                </div>
              `;
            };
            const renderButton = button => {
              if (!button.show) return '';
              return `
                <a
                  data-attribute="button-link-item"
                  data-show="true"
                  class="btn-banner-item"
                  href="${button.link || '#'}"
                  data-background="${button.background || '#003568'}"
                  data-color="${button.color || '#FFFFFF'}"
                  style="--button-background-color: ${button.background ||
                    '#003568'}; --button-text-color: ${button.color || '#FFFFFF'};"
                >
                  <span>${button.text || ''}</span>
                  <span class="icon">
                    <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0L3.2175 4.3875L0 8.775H2.145L5.3625 4.3875L2.145 0H0Z" fill="currentColor" />
                    </svg>
                  </span>
                </a>
              `;
            };
            const renderOutstanding = blockOutstanding => {
              if (!blockOutstanding.show) return '';
              const items = (blockOutstanding.items || [])
                .map(
                  item => `
                    <div class="item-otd" data-attribute="outstanding-item">
                      <div data-attribute="text-item-outstanding" class="text-item">
                        <h2>${item.heading || ''}</h2>
                        <p>${item.text || ''}</p>
                      </div>
                    </div>
                  `,
                )
                .join('');
              return `
                <div data-attribute="block-outstanding" data-show="true" class="block-outstanding">
                  ${items}
                </div>
              `;
            };

            elList.innerHTML = (updatedData[key] || [])
              .map(item => {
                const subtitle = item.subtitle || {};
                const title = item.title || {};
                const button = item.button || {};
                const blockOutstanding = item.blockOutstanding || {};

                return `
                  <div data-attribute="item" class="swiper-slide">
                    <div class="wrap-item-slide">
                      <div class="container-content-item">
                        <div class="container">
                          <div class="wrap-content">
                            ${renderSubtitle({
                              show: subtitle.show === undefined ? true : subtitle.show,
                              icon: subtitle.icon,
                              text: subtitle.text,
                              avatars: subtitle.avatars,
                            })}
                            ${renderTitle({
                              show: title.show === undefined ? true : title.show,
                              content: title.content,
                            })}
                            <div class="image-item-mb" data-show="${renderShowAttr(item.imageMobile !== '')}">
                              <img data-attribute="image-item-banner-mobile" src="${item.imageMobile || ''}" alt="" />
                            </div>
                            ${renderButton({
                              show: button.show === undefined ? true : button.show,
                              text: button.text,
                              link: button.link,
                              background: button.background,
                              color: button.color,
                            })}
                            ${renderOutstanding({
                              show: blockOutstanding.show === undefined ? true : blockOutstanding.show,
                              items: blockOutstanding.items,
                            })}
                          </div>
                        </div>
                      </div>
                      <div data-attribute="image-item-banner" class="image-item">
                        <img src="${item.imageDesktop || ''}" alt="" />
                      </div>
                    </div>
                  </div>
                `;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionGridItemKynorelle(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    for (const key in updatedData) {
      switch (key) {
        case 'title-card': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            const showTitle = !!updatedData[key]?.show;
            el.setAttribute('data-show', showTitle ? 'true' : 'false');
            el.style.display = showTitle ? '' : 'none';
            el.innerHTML = showTitle ? updatedData[key]?.content || '' : '';
          }
          break;
        }
        case 'show-slider': {
          const el = container.querySelector('[data-attribute="wrap-slider"]');
          if (el) {
            el.setAttribute('data-show', updatedData[key] ? 'true' : 'false');
            el.style.display = updatedData[key] ? '' : 'none';
          }
          break;
        }
        case 'image-banner-left-link': {
          const el = container.querySelector('[data-attribute="image-banner-left-link"]');
          if (el) {
            el.setAttribute('href', updatedData[key] || '#');
          }
          break;
        }
        case 'image-banner-right-link': {
          const el = container.querySelector('[data-attribute="image-banner-right-link"]');
          if (el) {
            el.setAttribute('href', updatedData[key] || '#');
          }
          break;
        }
        case 'image-banner-left': {
          const el = container.querySelector('[data-attribute="image-banner-left"]');
          if (el) {
            el.setAttribute('src', updatedData[key] || '');
          }
          break;
        }
        case 'image-banner-right': {
          const el = container.querySelector('[data-attribute="image-banner-right"]');
          if (el) {
            el.setAttribute('src', updatedData[key] || '');
          }
          break;
        }
        case 'list-item': {
          const showSlider = updatedData['show-slider'];
          const elList = container.querySelector('[data-attribute="list-item"]');
          if (elList) {
            const items = Array.isArray(updatedData[key]) ? updatedData[key] : [];
            elList.innerHTML = (updatedData[key] || [])
              .map(
                item => `
                  <div class="swiper-slide">
                    <div class="wrap-item-slide">
                      <img
                        data-attribute="image-item-slide"
                        src="${item.image || ''}"
                        alt=""
                      />
                    </div>
                  </div>
                `,
              )
              .join('');
            if (!showSlider && !items.length) {
              elList.innerHTML = '';
            }
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionGridItemKynorelle02(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const elTitle = container.querySelector('[data-attribute="section-title"]');
          if (elTitle) {
            elTitle.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'top-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottom-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'title-card': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            const showTitle = !!updatedData[key]?.show;
            el.setAttribute('data-show', showTitle ? 'true' : 'false');
            el.style.display = showTitle ? '' : 'none';
            el.innerHTML = showTitle ? updatedData[key]?.content || '' : '';
          }
          break;
        }
        case 'wrap-body-background': {
          const el = container.querySelector('[data-attribute="wrap-body-section"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
            el.style.setProperty('--background-color-body', updatedData[key]);
          }
          break;
        }
        case 'col-perview': {
          const el = container.querySelector('[data-attribute="block-img-product"]');
          if (el) {
            const colPerview = Number(updatedData[key]) || 1;
            el.setAttribute('data-col-perview', String(colPerview));
            el.style.setProperty('--col-perview', String(colPerview));
          }
          break;
        }
        case 'markqueue-items': {
          const el = container.querySelector('[data-attribute="block-markqueue"]');
          if (el) {
            el.innerHTML = (updatedData[key] || [])
              .map(
                item => `
                  <div data-attribute="item-markqueue" class="item-markqueue">
                    <div class="icon-item">
                      <img data-attribute="icon-item-markqueue" src="${item.icon || ''}" alt="" />
                    </div>
                    <div data-attribute="text-item-markqueue" class="text-item">
                      ${item.text || ''}
                    </div>
                  </div>
                `,
              )
              .join('');
          }
          break;
        }
        case 'list-item': {
          const elList = container.querySelector('[data-attribute="block-img-product"]');
          if (elList) {
            elList.innerHTML = (updatedData[key] || [])
              .map(
                item => `
                  <div data-attribute="item" class="item-img-product">
                    <img data-attribute="image-item-img-product" src="${item.image || ''}" alt="" />
                  </div>
                `,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionMarkqueueKynorelle(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const elTitle = container.querySelector('[data-attribute="section-title"]');
          if (elTitle) {
            elTitle.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'top-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottom-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'background-markqueue': {
          const el = container.querySelector('[data-attribute="container-markqueue"]');
          if (el) {
            el.setAttribute('data-background-markqueue', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
            el.style.setProperty('--background-color-markqueue', updatedData[key]);
          }
          break;
        }
        case 'markqueue-items': {
          const el = container.querySelector('[data-attribute="block-markqueue"]');
          if (el) {
            el.removeAttribute('data-markqueue-duplicated');
            el.innerHTML = (updatedData[key] || [])
              .map(
                item => `
                  <div data-attribute="item-markqueue" class="item-markqueue">
                    <div class="icon-item">
                      <img data-attribute="icon-item-markqueue" src="${item.icon || ''}" alt="" />
                    </div>
                    <div data-attribute="text-item-markqueue" class="text-item">
                      ${item.text || ''}
                    </div>
                  </div>
                `,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionMarqueeKyroro(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const elTitle = container.querySelector('[data-attribute="section-title"]');
          if (elTitle) {
            elTitle.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'top-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottom-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'background-markqueue': {
          const el = container.querySelector('[data-attribute="container-markqueue"]');
          if (el) {
            el.setAttribute('data-background-markqueue', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
            el.style.setProperty('--background-color-markqueue', updatedData[key]);
          }
          break;
        }
        case 'markqueue-items': {
          const el = container.querySelector('[data-attribute="block-markqueue"]');
          if (el) {
            el.removeAttribute('data-markqueue-duplicated');
            el.innerHTML = (updatedData[key] || [])
              .map(
                item => `
                  <a href="${item.link || '#'}" target="_blank" data-attribute="item-markqueue" class="item-markqueue">
                    <div class="icon-item">
                      <img data-attribute="icon-item-markqueue" src="${item.icon || ''}" alt="" />
                    </div>
                    <div data-attribute="text-item-markqueue" class="text-item">
                      ${item.text || ''}
                    </div>
                  </a>
                `,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionMarqueeBoxerItem(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const renderStars = value => {
      const count = Math.floor(Math.max(0, Math.min(5, Number(value) || 0)));
      return Array(count)
        .fill(
          `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor" />
          </svg>`,
        )
        .join('');
    };

    if (updatedData.cardTitle) {
      const cardTitle = container.querySelector('[data-attribute="card-title"]');
      if (cardTitle) {
        const show = !!updatedData.cardTitle.show;
        cardTitle.setAttribute('data-show', show ? 'true' : 'false');
        cardTitle.style.display = show ? 'block' : 'none';
        cardTitle.innerHTML = show ? updatedData.cardTitle.content || '' : '';
      }
    }

    const blockMarquee = container.querySelector('[data-attribute="block-marquee"]');
    if (blockMarquee && updatedData.blockMarquee) {
      const colPerView = Number(updatedData.blockMarquee.colPerView) || 4;
      const itemWidth = Number(updatedData.blockMarquee.itemWidth);
      const itemGap = Number(updatedData.blockMarquee.itemGap);
      const spaceBetween = Number(updatedData.blockMarquee.spaceBetween);
      const finalSpace = Number.isFinite(spaceBetween) && spaceBetween >= 0 ? spaceBetween : 30;
      const radiusItem = Number(updatedData.blockMarquee.radiusItem);
      const finalRadius = Number.isFinite(radiusItem) && radiusItem >= 0 ? radiusItem : 10;
      const backgroundItem = updatedData.blockMarquee.backgroundItem || '#3c3c3c';
      const speed = Number(updatedData.blockMarquee.speed);
      blockMarquee.removeAttribute('data-list-duplicated');
      blockMarquee.setAttribute('data-col-per-view', String(colPerView));
      blockMarquee.setAttribute('data-space-between', String(finalSpace));
      blockMarquee.setAttribute('data-background-item', backgroundItem);
      blockMarquee.setAttribute('data-radius-item', String(finalRadius));
      blockMarquee.setAttribute('data-item-width', String(itemWidth));
      blockMarquee.setAttribute('data-item-gap', String(itemGap));
      blockMarquee.setAttribute('data-speed', String(speed));
      blockMarquee.style.setProperty('--col-per-view', String(colPerView));
      blockMarquee.style.setProperty('--space-between', `${finalSpace}px`);
      blockMarquee.style.setProperty('--bg-item-color', backgroundItem);
      blockMarquee.style.setProperty('--border-radius', `${finalRadius}px`);
      blockMarquee.style.setProperty('--speed', `${speed}s`);
      blockMarquee.style.setProperty('--item-width', `${itemWidth}px`);
      blockMarquee.style.setProperty('--item-gap', `${itemGap}px`);
    }

    if (blockMarquee && Array.isArray(updatedData.items)) {
      const listItems = Array.from(blockMarquee.children).filter(
        child => child.getAttribute('data-attribute') === 'list-item',
      );
      const listItem = listItems[0] || document.createElement('div');
      listItem.setAttribute('data-attribute', 'list-item');
      listItem.className = 'list-item';
      listItems.slice(1).forEach(item => item.remove());
      if (!listItems.length) {
        blockMarquee.appendChild(listItem);
      }

      listItem.innerHTML = updatedData.items
        .map(item => {
          const ratingShow = item.rating?.show !== false;
          const ratingValue = Number(item.rating?.value) || 4;
          const descriptionShow = item.description?.show !== false;
          return `
            <div data-attribute="item" class="item-marquee">
              <a href="${item.link || '#'}" data-attribute="link-item" target="_blank" class="wrap-item">
                <div class="wrap-img">
                  <img data-attribute="image-item" src="${item.image || ''}" alt="" />
                </div>
                <div data-attribute="wrap-rating" data-show="${
                  ratingShow ? 'true' : 'false'
                }" data-value="${ratingValue}" class="wrap-rating" style="display: ${ratingShow ? '' : 'none'};">
                  ${renderStars(ratingValue)}
                </div>
                <div data-attribute="description-item" data-show="${
                  descriptionShow ? 'true' : 'false'
                }" class="description-item" style="display: ${descriptionShow ? '' : 'none'};">
                  ${item.description?.content || ''}
                </div>
              </a>
            </div>
          `;
        })
        .join('');
    }

    return container.innerHTML.trim();
  },
  sectionGridItemKynorelle03(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const elTitle = container.querySelector('[data-attribute="section-title"]');
          if (elTitle) {
            elTitle.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'top-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottom-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'title-card': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            const showTitle = !!updatedData[key]?.show;
            el.setAttribute('data-show', showTitle ? 'true' : 'false');
            el.style.display = showTitle ? '' : 'none';
            el.innerHTML = showTitle ? updatedData[key]?.content || '' : '';
          }
          break;
        }
        case 'col-perview': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            const colPerview = Number(updatedData[key]) || 1;
            el.setAttribute('data-col-perview', String(colPerview));
            el.style.setProperty('--col-perview', String(colPerview));
          }
          break;
        }
        case 'list-item': {
          const elList = container.querySelector('[data-attribute="list-item"]');
          if (elList) {
            elList.innerHTML = (updatedData[key] || [])
              .map(
                item => `
                  <div data-attribute="item" class="item-product">
                    <div class="wrap-img">
                      <img
                        data-attribute="image-item-product"
                        class="image-item-product"
                        src="${item.image || ''}"
                        alt=""
                      />
                    </div>
                    <div data-background="${item.background || '#FFFFFF'}" data-text-color="${item.textColor ||
                  '#000000'}" data-attribute="label-product" class="label-product" style="background-color: ${item.background ||
                  '#FFFFFF'}; color: ${item.textColor || '#000000'};">${item.label || ''}</div>
                  </div>
                `,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionGridItemKynorelle04(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const elTitle = container.querySelector('[data-attribute="section-title"]');
          if (elTitle) {
            elTitle.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'top-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottom-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'title-card': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            const showTitle = !!updatedData[key]?.show;
            el.setAttribute('data-show', showTitle ? 'true' : 'false');
            el.style.display = showTitle ? '' : 'none';
            el.innerHTML = showTitle ? updatedData[key]?.content || '' : '';
          }
          break;
        }
        case 'list-item': {
          const elList = container.querySelector('[data-attribute="list-item"]');
          if (elList) {
            elList.innerHTML = (updatedData[key] || [])
              .map(
                item => `
                  <div data-attribute="item" class="swiper-slide">
                    <div class="wrap-item">
                      <div data-attribute="content-review" class="content-review">
                        ${item.content || ''}
                      </div>
                      <div class="wrap-img">
                        <img data-attribute="image-item" src="${item.image || ''}" alt="" />
                      </div>
                      <div data-attribute="reviewer-name" class="reviewer-name">
                        ${item.reviewer || ''}
                      </div>
                      <div class="verified">
                        <span class="icon"
                          ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                              fill="#42ADA4"
                            />
                            <path
                              d="M11.8175 4.56738L6.88753 9.49738L4.85753 7.46738L3.84253 8.48238L6.88753 11.5274L12.8325 5.58238L11.8175 4.56738Z"
                              fill="#E3F2FD"
                            />
                          </svg>
                        </span>
                        <span>verified buyer</span>
                      </div>
                    </div>
                  </div>
                `,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionGridItemKynorelle05(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const elTitle = container.querySelector('[data-attribute="section-title"]');
          if (elTitle) {
            elTitle.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'top-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottom-padding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'title-card': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            const showTitle = !!updatedData[key]?.show;
            el.setAttribute('data-show', showTitle ? 'true' : 'false');
            el.style.display = showTitle ? '' : 'none';
            el.innerHTML = showTitle ? updatedData[key]?.content || '' : '';
          }
          break;
        }
        case 'image-heading': {
          const el = container.querySelector('[data-attribute="image-heading"]');
          if (el) {
            el.setAttribute('src', updatedData[key] || '');
          }
          break;
        }
        case 'text-heading': {
          const el = container.querySelector('[data-attribute="text-heading"]');
          if (el) {
            el.innerHTML = updatedData[key] || '';
          }
          break;
        }
        case 'highlight-text': {
          const el = container.querySelector('[data-attribute="highlight-text"]');
          if (el) {
            const showVal = !!updatedData[key]?.show;
            el.setAttribute('data-show', showVal ? 'true' : 'false');
            el.style.display = showVal ? 'block' : 'none';
            el.innerHTML = updatedData[key]?.content || '';
          }
          break;
        }
        case 'image-content': {
          const el = container.querySelector('[data-attribute="image-content"]');
          if (el) {
            el.setAttribute('src', updatedData[key] || '');
          }
          break;
        }
        case 'text-content': {
          const el = container.querySelector('[data-attribute="text-content"]');
          if (el) {
            el.innerHTML = updatedData[key] || '';
          }
          break;
        }
        case 'button': {
          const el = container.querySelector('[data-attribute="button-link"]');
          if (el) {
            const showVal = !!updatedData[key]?.show;
            el.setAttribute('data-show', showVal ? 'true' : 'false');
            el.style.display = showVal ? 'inline-flex' : 'none';
            el.setAttribute('href', updatedData[key]?.link || '#');
            el.setAttribute('data-background', updatedData[key]?.background || '#003568');
            el.style.setProperty('--button-background-color', updatedData[key]?.background || '#003568');
            el.setAttribute('data-color', updatedData[key]?.color || '#ffffff');
            el.style.setProperty('--button-text-color', updatedData[key]?.color || '#ffffff');
            const label = el.querySelector('span:not(.icon)');
            if (label) {
              label.textContent = updatedData[key]?.text || '';
            }
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionTextWithIcon(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const listItemEl = container.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      const bgIcon = updatedData.bgIcon || listItemEl.getAttribute('data-bg-icon') || '#003568';
      const colPerViewRaw = Number(updatedData.colPerView);
      const colPerView =
        Number.isFinite(colPerViewRaw) && colPerViewRaw > 0
          ? colPerViewRaw
          : Number(listItemEl.getAttribute('data-col-perview')) || 4;

      listItemEl.setAttribute('data-bg-icon', bgIcon);
      listItemEl.setAttribute('data-col-perview', String(colPerView));
      listItemEl.style.setProperty('--bg-icon', bgIcon);
      listItemEl.style.setProperty('--col-perview', String(colPerView));

      if (Array.isArray(updatedData.items)) {
        listItemEl.innerHTML = updatedData.items
          .map(
            item => `
              <div data-attribute="item" class="item-icon-with-text">
                <div data-attribute="icon-item" class="icon-item" style="background-color: ${bgIcon};">
                  <img data-attribute="icon-image" src="${item.icon || ''}" alt="" />
                </div>
                <div data-attribute="text-item" class="text-item">
                  ${item.content || ''}
                </div>
              </div>
            `,
          )
          .join('');
      } else {
        const iconItems = listItemEl.querySelectorAll('[data-attribute="icon-item"]');
        iconItems.forEach(iconEl => {
          iconEl.style.backgroundColor = bgIcon;
        });
      }
    }

    if (updatedData.titleCard) {
      const titleCardEl = container.querySelector('[data-attribute="title-card"]');
      if (titleCardEl) {
        const show = !!updatedData.titleCard.show;
        titleCardEl.setAttribute('data-show', show ? 'true' : 'false');
        titleCardEl.style.display = show ? '' : 'none';
        titleCardEl.innerHTML = show ? updatedData.titleCard.content || '' : '';
      }
    }

    return container.innerHTML.trim();
  },
  sectionCardHsiaTextWithIcon(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl) {
            sectionEl.setAttribute('data-title', updatedData[key] || '');
          }
          break;
        }
        case 'styleSection': {
          const cardContainer = container.querySelector('[data-attribute="card-container"]');
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]?.topPadding ? 'true' : 'false');
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]?.bottomPadding ? 'true' : 'false');
            cardContainer.setAttribute('data-background', updatedData[key]?.background || '#FFFFFF');
            cardContainer.setAttribute('data-text-color', updatedData[key]?.textColor || '#000000');
            cardContainer.style.backgroundColor = updatedData[key]?.background || '#FFFFFF';
            cardContainer.style.color = updatedData[key]?.textColor || '#000000';
            cardContainer.style.setProperty('--text-color', updatedData[key]?.textColor || '#000000');
          }
          break;
        }
        case 'containerPage': {
          const containerPage = container.querySelector('[data-attribute="container-page"]');
          if (containerPage) {
            const enableStyle = updatedData[key]?.enableStyle === true;
            const background = updatedData[key]?.background || '#FFFFFF';
            containerPage.setAttribute('data-enable-style', enableStyle ? 'true' : 'false');
            containerPage.setAttribute('data-background-container', background);
            containerPage.style.backgroundColor = enableStyle ? background : 'transparent';
          }
          break;
        }
        case 'cardTitle': {
          const cardTitle = container.querySelector('[data-attribute="card-title"]');
          if (cardTitle) {
            const show = updatedData[key]?.show !== false;
            cardTitle.setAttribute('data-show', show ? 'true' : 'false');
            cardTitle.style.display = show ? '' : 'none';
            cardTitle.innerHTML = show ? updatedData[key]?.content || '' : '';
          }
          break;
        }
        case 'listStyle': {
          const listEl = container.querySelector('[data-attribute="list-item"]');
          if (listEl) {
            const bgItemColor = updatedData[key]?.bgItemColor || '#F5F5F5';
            const borderItemRadius = updatedData[key]?.borderItemRadius || 10;
            listEl.setAttribute('data-bg-item-color', bgItemColor);
            listEl.setAttribute('data-border-item-radius', borderItemRadius);
            listEl.style.setProperty('--bg-item-color', bgItemColor);
            listEl.style.setProperty('--border-item-radius', `${borderItemRadius}px`);
          }
          break;
        }
        case 'items': {
          const listEl = container.querySelector('[data-attribute="list-item"]');
          if (listEl) {
            const items = (Array.isArray(updatedData[key]) ? updatedData[key] : []).filter(Boolean);
            listEl.innerHTML = items
              .map(item => {
                return `<a href="${item.link || '#'}" data-attribute="item" class="wrap-item">
        <div class="wrap-img-item">
          <img data-attribute="image-item" src="${item.image || ''}" alt="" />
        </div>
        <div data-attribute="text-item" class="text-item">
          ${item.content || ''}
        </div>
      </a>`;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionProductWithVariant(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const escapeAttr = value =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    const escapeHtml = value =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    const starSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>star</title><path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" fill="currentColor" /></svg>`;

    const buildImagesHtml = (variants = {}) => {
      const keys = Object.keys(variants);
      return keys
        .map(key => {
          const variant = variants[key] || {};
          const active = !!variant.active;
          const imagesHtml = (variant.images || []).length
            ? variant.images
                .map(
                  (imgItem, index) =>
                    `<div class="wrap-img-color ${
                      index === 0 && active ? 'active' : ''
                    }"><img data-attribute="image-color-variant" src="${escapeAttr(
                      imgItem?.image || '',
                    )}" alt="" /></div>`,
                )
                .join('')
            : `<div class="wrap-img-color"><img data-attribute="image-color-variant" src="" alt="" /></div>`;
          return `<div data-attribute="color-variant" data-color="${escapeAttr(
            variant.color || '#000000',
          )}" data-color-variant="${escapeAttr(key)}" data-active="${active}" class="color-variant${
            active ? ' active' : ''
          }">${imagesHtml}</div>`;
        })
        .join('');
    };

    const buildSwatchHtml = (variants = {}) => {
      const keys = Object.keys(variants);
      return keys
        .map((key, index, arrayKeys) => {
          const variant = variants[key] || {};
          const active = !!variant.active;
          return `
          <div class="item-swatches">
            <div data-attribute="color-variant" data-sold-out="${!!variant.soldOut}" data-color-variant="${escapeAttr(
            key,
          )}" data-label="${escapeAttr(variant.label || key)}" data-active="${active}" data-use-thumbnail="${
            variant.useThumbnail ? 'true' : 'false'
          }" style="background:${escapeAttr(variant.color || '#000000')}; --color-variant: ${escapeAttr(
            variant.color || '#000000',
          )};" class="color-variant${active ? ' active' : ''}${index > 2 ? ' hidden-item' : ''}">
              ${
                variant.useThumbnail
                  ? `<img data-attribute="thumbnail-color-variant" src="${escapeAttr(
                      variant.thumbnail || '',
                    )}" alt="${escapeAttr(variant.label || key)}" />`
                  : ''
              }
              </div>
              <div class="label-swatches">${escapeAttr(variant.label || key)}</div>
            </div>
          `;
        })
        .join('');
    };

    const buildProductItemHtml = item => {
      const rating = item.rating || {};
      const variants = item.colorVariants || {};
      const price = item.productPrice || {};
      const variantCount = Object.keys(variants).length;
      const moreText = variantCount > 3 ? `+ ${variantCount - 3} more` : '';
      const linkProduct = item.linkProduct || '#';
      return `
        <div data-attribute="product-item" class="swiper-slide">
          <div class="wrap-product">
            <div class="block-imgs-product">
              <a href="${linkProduct}" data-attribute="list-img-color-variant" class="wrap-images">
                ${buildImagesHtml(variants)}
              </a>
              <div class="group-pagination">
                <div class="prev-product">
                  <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.82866 13.9995C5.53666 13.9995 5.24666 13.8725 5.04866 13.6265L0.22066 7.6265C-0.07734 7.2555 -0.07334 6.7255 0.23166 6.3595L5.23166 0.359495C5.58466 -0.0645046 6.21566 -0.121505 6.64066 0.231495C7.06466 0.584495 7.12166 1.2155 6.76766 1.6395L2.29266 7.0105L6.60766 12.3725C6.95366 12.8025 6.88566 13.4325 6.45466 13.7785C6.27066 13.9275 6.04866 13.9995 5.82866 13.9995Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <div class="next-product">
                  <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.999495 13.9998C0.773495 13.9998 0.546495 13.9238 0.359495 13.7678C-0.0645046 13.4148 -0.121505 12.7838 0.231495 12.3598L4.7075 6.98883L0.392495 1.62683C0.0464955 1.19683 0.114495 0.566829 0.544495 0.220829C0.975495 -0.125171 1.6045 -0.0571711 1.9515 0.372829L6.7795 6.37283C7.0775 6.74383 7.0735 7.27383 6.7685 7.63983L1.7685 13.6398C1.5705 13.8768 1.2865 13.9998 0.999495 13.9998Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </div>
              <div class="quick-buy">
                <span>Quick Buy</span>
              </div>
            </div>
            <div data-attribute="product-info" class="product-info">
              <div data-attribute="product-name" class="product-name">
                ${item.productName || ''}
              </div>
              <div data-attribute="product-price" class="product-price">
                <div data-attribute="from-text" class="from-text">${escapeHtml(price.fromText || 'From')}</div>
                <div data-attribute="price-new" class="price-new">${escapeHtml(price.priceNew || '')}</div>
                <div data-attribute="price-old" class="price-old">${escapeHtml(price.priceOld || '')}</div>
                <div data-attribute="state-product" class="state-product">${escapeHtml(price.stateProduct || '')}</div>
              </div>
              <div class="block-color-variants">
                <div data-attribute="list-color-variant" class="list-color-variant">
                  ${buildSwatchHtml(variants)}
                </div>
                <div data-attribute="more-color-variant" class="more-color-variant"><span>${escapeHtml(
                  moreText,
                )}</span></div>
              </div>
              <div class="block-rating">
                <div data-attribute="stars" data-value="${escapeHtml(
                  rating.value || 5,
                )}" class="stars">${starSvg.repeat(rating.value)}</div>
                <div data-attribute="review-count" class="review-count">${escapeHtml(
                  rating.reviewCount || '4 reviews',
                )}</div>
              </div>
            </div>
          </div>
        </div>
      `;
    };

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl) {
            sectionEl.setAttribute('data-title', updatedData[key] || '');
          }
          break;
        }
        case 'styleSection': {
          const cardContainer = container.querySelector('[data-attribute="card-container"]');
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]?.topPadding ? 'true' : 'false');
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]?.bottomPadding ? 'true' : 'false');
            cardContainer.setAttribute('data-background', updatedData[key]?.background || '#FFFFFF');
            cardContainer.setAttribute('data-text-color', updatedData[key]?.textColor || '#000000');
            cardContainer.style.backgroundColor = updatedData[key]?.background || '#FFFFFF';
            cardContainer.style.color = updatedData[key]?.textColor || '#000000';
            cardContainer.style.setProperty('--text-color', updatedData[key]?.textColor || '#000000');
          }
          break;
        }
        case 'containerPage': {
          const containerPage = container.querySelector('[data-attribute="container-page"]');
          if (containerPage) {
            containerPage.setAttribute('data-enable-style', updatedData[key]?.enableStyle ? 'true' : 'false');
            containerPage.setAttribute('data-background-container', updatedData[key]?.background || '#FFFFFF');
            containerPage.style.backgroundColor = updatedData[key]?.enableStyle
              ? updatedData[key]?.background || '#FFFFFF'
              : 'transparent';
          }
          break;
        }
        case 'cardTitle': {
          const cardTitle = container.querySelector('[data-attribute="card-title"]');
          const showCardTitle = !!updatedData['showCardTitle'];
          if (cardTitle) {
            cardTitle.innerHTML = showCardTitle ? updatedData[key] || '' : '';
            cardTitle.setAttribute('data-show', showCardTitle ? 'true' : 'false');
            cardTitle.style.display = showCardTitle ? 'block' : 'none';
          }
          break;
        }
        case 'colPerView': {
          const listItemEl = container.querySelector('[data-attribute="list-item"]');
          if (listItemEl) {
            const colPerView = Number(updatedData[key]) > 0 ? Number(updatedData[key]) : 1;
            listItemEl.setAttribute('data-col-perview', String(colPerView));
            listItemEl.style.setProperty('--col-perview', String(colPerView));
          }
          break;
        }
        case 'spaceBetween': {
          const listItemEl = container.querySelector('[data-attribute="list-item"]');
          if (listItemEl) {
            const spaceBetween = Number(updatedData[key]) >= 0 ? Number(updatedData[key]) : 0;
            listItemEl.setAttribute('data-space-between', String(spaceBetween));
            listItemEl.style.setProperty('--space-between', `${spaceBetween}px`);
          }
          break;
        }
        case 'listItem': {
          const listItemEl = container.querySelector('[data-attribute="list-item"]');
          if (listItemEl) {
            const items = Array.isArray(updatedData[key]) ? updatedData[key] : [];
            listItemEl.innerHTML = items.map(buildProductItemHtml).join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionSliderItemFyroro(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const renderSlideItem = (item, common) => {
      const { showPrice = true, showDiscountTag = true, discountBg = '#6293c1', discountColor = '#ffffff' } =
        common || {};
      const showDiscount = showDiscountTag && item.showDiscount;

      return `
        <div class="swiper-slide">
          <a href="${item.link || '#'}" data-attribute="item-product" class="wrap-item">
            <div class="wrap-img">
              <img data-attribute="image-product" src="${item.image || ''}" alt="" />
              <div data-attribute="save-discount" data-show="${showDiscount}" class="save-discount" style="display: ${
        showDiscount ? 'flex' : 'none'
      }; background: ${discountBg}; color: ${discountColor};">
                <span class="icon-discount">
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    class="icon icon-discount color-foreground-text"
                    viewBox="0 0 12 12"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </span>
                <span data-attribute="text-discount" class="text-discount">${item.discountText || 'Save 20%'}</span>
              </div>
            </div>
            <div class="wrap-content">
              <div data-attribute="product-name" class="product-name">${item.productName || ''}</div>
              <div class="product-price" style="display: ${showPrice ? 'flex' : 'none'};">
                <span data-attribute="from-text" class="from-text">${item.fromText || 'From'}</span>
                <span data-attribute="price-new" class="price-new">${item.priceNew || '$0.00'}</span>
                <span data-attribute="price-old" class="price-old">${item.priceOld || '$0.00'}</span>
              </div>
            </div>
          </a>
        </div>
      `;
    };

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'settings': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]?.backgroundColor || '#FFFFFF');
            el.style.backgroundColor = updatedData[key]?.backgroundColor || '#FFFFFF';
            el.setAttribute('data-top-padding', updatedData[key]?.paddingTop ? 'true' : 'false');
            el.setAttribute('data-bottom-padding', updatedData[key]?.paddingBottom ? 'true' : 'false');
            el.setAttribute('data-text-color', updatedData[key]?.textColor || '#000000');
            el.style.color = updatedData[key]?.textColor || '#000000';
            el.style.setProperty('--text-color', updatedData[key]?.textColor || '#000000');
          }
          break;
        }
        case 'titleCard': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            el.innerHTML = updatedData[key] || '';
          }
          break;
        }
        case 'slider': {
          const el = container.querySelector('[data-attribute="slider-product"]');
          if (el) {
            el.setAttribute('data-slide-per-view', updatedData[key]?.slidesPerView || 3);
            el.setAttribute('data-show-price', updatedData[key]?.showPrice ? 'true' : 'false');
            el.setAttribute('data-show-discount-tag', updatedData[key]?.showDiscountTag ? 'true' : 'false');
            el.setAttribute('data-background-discount-tag', updatedData[key]?.discountBg || '#6293c1');
            el.setAttribute('data-color-discount-tag', updatedData[key]?.discountColor || '#ffffff');
            el.style.setProperty('--background-discount-tag', updatedData[key]?.discountBg || '#6293c1');
            el.style.setProperty('--color-discount-tag', updatedData[key]?.discountColor || '#ffffff');
          }
          break;
        }
        case 'button': {
          const buttonWrap = container.querySelector('.wrap-btn');
          const buttonEl = container.querySelector('[data-attribute="btn-view-all"]');
          if (buttonWrap) {
            buttonWrap.setAttribute('data-show-btn', updatedData[key]?.show ? 'true' : 'false');
            buttonWrap.style.display = updatedData[key]?.show ? 'block' : 'none';
          }
          if (buttonEl) {
            buttonEl.textContent = updatedData[key]?.text || 'View All';
            buttonEl.setAttribute('href', updatedData[key]?.link || 'javascript:void(0)');
            buttonEl.setAttribute('data-background', updatedData[key]?.background || '#000000');
            buttonEl.setAttribute('data-color', updatedData[key]?.color || '#ffffff');
            buttonEl.setAttribute('data-radius', updatedData[key]?.radius || '0');
            buttonEl.style.background = updatedData[key]?.background || '#000000';
            buttonEl.style.color = updatedData[key]?.color || '#ffffff';
            buttonEl.style.borderRadius = `${updatedData[key]?.radius || 0}px`;
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            const sliderData = updatedData.slider || {};
            el.innerHTML = (updatedData[key] || []).map(item => renderSlideItem(item, sliderData)).join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionSliderItemBoxer(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const STAR_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>star</title><path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" fill="currentColor"/></svg>`;

    const renderStars = value => {
      const safe = Math.max(0, Math.min(5, Number(value) || 0));
      return Array(safe)
        .fill(STAR_SVG)
        .join('');
    };

    const renderSlideItem = item => {
      const rating = item.rating || { show: true, value: 4 };
      const description = item.description || { show: true, text: '' };
      return `
        <div data-attribute="item" class="swiper-slide">
          <a href="${item.link ||
            '#'}" data-attribute="link-item" target="_blank" data-attribute="link-item-content" class="wrap-item">
            <div class="wrap-img">
              <img data-attribute="image-item" src="${item.image || ''}" alt="" />
            </div>
            <div
              data-attribute="wrap-rating"
              data-show="${rating.show ? 'true' : 'false'}"
              data-value="${rating.value || 0}"
              class="wrap-rating"
              style="display: ${rating.show ? 'flex' : 'none'};"
            >
              ${renderStars(rating.value)}
            </div>
            <div
              data-attribute="description-item"
              data-show="${description.show ? 'true' : 'false'}"
              class="description-item"
              style="display: ${description.show ? 'block' : 'none'};"
            >
              ${description.text || ''}
            </div>
          </a>
        </div>
      `;
    };

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key] || '');
          }
          break;
        }
        case 'styleSection': {
          const cardContainer = container.querySelector('[data-attribute="card-container"]');
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]?.topPadding ? 'true' : 'false');
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]?.bottomPadding ? 'true' : 'false');
            cardContainer.setAttribute('data-background', updatedData[key]?.background || '#FFFFFF');
            cardContainer.setAttribute('data-text-color', updatedData[key]?.textColor || '#000000');
            cardContainer.style.backgroundColor = updatedData[key]?.background || '#FFFFFF';
            cardContainer.style.color = updatedData[key]?.textColor || '#000000';
            cardContainer.style.setProperty('--text-color', updatedData[key]?.textColor || '#000000');
          }
          break;
        }
        case 'containerPage': {
          const containerPage = container.querySelector('[data-attribute="container-page"]');
          if (containerPage) {
            const enableStyle = updatedData[key]?.enableStyle === true;
            const background = updatedData[key]?.background || '#FFFFFF';
            containerPage.setAttribute('data-enable-style', enableStyle ? 'true' : 'false');
            containerPage.setAttribute('data-background-container', background);
            containerPage.style.backgroundColor = enableStyle ? background : 'transparent';
          }
          break;
        }
        case 'titleCard': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            const show = updatedData[key]?.show !== false;
            el.setAttribute('data-show', show ? 'true' : 'false');
            el.style.display = show ? '' : 'none';
            el.innerHTML = show ? updatedData[key]?.content || '' : '';
          }
          break;
        }
        case 'wrapItems': {
          const el = container.querySelector('[data-attribute="wrap-items"]');
          if (el) {
            const colPerView = updatedData[key]?.colPerView || 3;
            const spaceBetween = updatedData[key]?.spaceBetween || 30;
            const itemBackground = updatedData[key]?.itemBackground || '#eff3fa';
            const itemBorderRadius = updatedData[key]?.itemBorderRadius || 10;
            const colorStar = updatedData[key]?.colorStar || '#FFD700';
            el.setAttribute('data-col-per-view', colPerView);
            el.setAttribute('data-space-between', spaceBetween);
            el.setAttribute('data-item-background', itemBackground);
            el.setAttribute('data-item-border-radius', itemBorderRadius);
            el.setAttribute('data-color-star', colorStar);
            el.style.setProperty('--item-background', itemBackground);
            el.style.setProperty('--item-border-radius', `${itemBorderRadius}px`);
            el.style.setProperty('--color-star', colorStar);
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.innerHTML = (updatedData[key] || []).map(item => renderSlideItem(item)).join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionFreestyle(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const content = container.querySelector('[data-attribute="content"]');
    if (content) {
      content.innerHTML = updatedData['content'] || '';
    }
    return container.innerHTML.trim();
  },
  sectionCardGridBoxer(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.titleCard) {
      const titleCardEl = container.querySelector('[data-attribute="title-card"]');
      if (titleCardEl) {
        const show = !!updatedData.titleCard.show;
        titleCardEl.setAttribute('data-show', show ? 'true' : 'false');
        titleCardEl.style.display = show ? '' : 'none';
        titleCardEl.innerHTML = show ? updatedData.titleCard.content || '' : '';
      }
    }

    if (updatedData.listItem) {
      const listItemEl = container.querySelector('[data-attribute="list-item"]');
      if (listItemEl) {
        const colPerView = Number(updatedData.listItem.colPerView) || 4;
        const spaceBetween = Number(updatedData.listItem.spaceBetween);
        const finalSpace = Number.isFinite(spaceBetween) && spaceBetween >= 0 ? spaceBetween : 30;
        const sttShow = !!updatedData.listItem.sttShow;
        const sttBackground = updatedData.listItem.sttBackground || '#606f99';
        const sttColor = updatedData.listItem.sttColor || '#FFFFFF';

        listItemEl.setAttribute('data-col-perview', String(colPerView));
        listItemEl.setAttribute('data-space-between', String(finalSpace));
        listItemEl.setAttribute('data-show-stt', sttShow ? 'true' : 'false');
        listItemEl.setAttribute('data-background-stt', sttBackground);
        listItemEl.setAttribute('data-color-stt', sttColor);
        listItemEl.style.setProperty('--col-perview', String(colPerView));
        listItemEl.style.setProperty('--space-between', `${finalSpace}px`);
        listItemEl.style.setProperty('--background-stt', sttBackground);
        listItemEl.style.setProperty('--color-stt', sttColor);

        listItemEl.innerHTML = (updatedData.listItem.items || [])
          .map(
            item => `
              <div data-attribute="item" class="wrap-item">
                <div class="wrap-img">
                  <img data-attribute="image-item" src="${item.image || ''}" alt="" />
                  <div data-attribute="stt-item" class="stt-item">${item.stt || ''}</div>
                </div>
                <div data-attribute="text-item" class="text-item">${item.text || ''}</div>
              </div>
            `,
          )
          .join('');
      }
    }

    if (updatedData.button) {
      const btnEl = container.querySelector('[data-attribute="btn"]');
      if (btnEl) {
        const show = !!updatedData.button.show;
        const background = updatedData.button.background || '#606f99';
        const color = updatedData.button.color || '#FFFFFF';
        const radius = Number(updatedData.button.radius);
        const finalRadius = Number.isFinite(radius) ? radius : 6;
        btnEl.setAttribute('data-show', show ? 'true' : 'false');
        btnEl.setAttribute('href', updatedData.button.link || '#');
        btnEl.setAttribute('data-background-btn', background);
        btnEl.setAttribute('data-color-btn', color);
        btnEl.setAttribute('data-radius-btn', String(finalRadius));
        btnEl.style.backgroundColor = background;
        btnEl.style.color = color;
        btnEl.style.borderRadius = `${finalRadius}px`;
        btnEl.style.display = show ? '' : 'none';
        const btnTextEl = btnEl.querySelector('[data-attribute="btn-text"]');
        if (btnTextEl) {
          btnTextEl.textContent = updatedData.button.text || '';
        }
      }
    }

    if (updatedData.policy) {
      const policyEl = container.querySelector('[data-attribute="policy-sub"]');
      if (policyEl) {
        const show = !!updatedData.policy.show;
        const colPerView = Number(updatedData.policy.colPerView) || 2;
        policyEl.setAttribute('data-show', show ? 'true' : 'false');
        policyEl.setAttribute('data-col-perview', String(colPerView));
        policyEl.style.setProperty('--col-perview', String(colPerView));
        policyEl.style.display = show ? '' : 'none';
        policyEl.innerHTML = (updatedData.policy.items || [])
          .map(
            item => `
              <div data-attribute="policy-item" class="policy-item">
                <div class="icon">
                  <img data-attribute="icon-image" src="${item.icon || ''}" alt="" />
                </div>
                <div data-attribute="policy-text" class="policy-item-text">${item.text || ''}</div>
              </div>
            `,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },
  sectionCardWithTabsBoxer(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.titleCard) {
      const titleCardEl = container.querySelector('[data-attribute="title-card"]');
      if (titleCardEl) {
        const show = !!updatedData.titleCard.show;
        titleCardEl.setAttribute('data-show', show ? 'true' : 'false');
        titleCardEl.style.display = show ? '' : 'none';
        titleCardEl.innerHTML = show ? updatedData.titleCard.content || '' : '';
      }
    }

    if (updatedData.listTabContent) {
      const listContentEl = container.querySelector('[data-attribute="list-tab-content"]');
      if (listContentEl) {
        const colPerView = Number(updatedData.listTabContent.colPerView) || 4;
        const spaceBetween = Number(updatedData.listTabContent.spaceBetween);
        const finalSpace = Number.isFinite(spaceBetween) && spaceBetween >= 0 ? spaceBetween : 30;
        const borderRadius = Number(updatedData.listTabContent.borderRadius);
        const finalRadius = Number.isFinite(borderRadius) && borderRadius >= 0 ? borderRadius : 0;
        const background = updatedData.listTabContent.background || '#ffffff';
        const border = updatedData.listTabContent.border || '#eff3fa';
        const colorItem = updatedData.listTabContent.colorItem || '#000000';

        listContentEl.setAttribute('data-col-per-view', String(colPerView));
        listContentEl.setAttribute('data-space-between', String(finalSpace));
        listContentEl.setAttribute('data-border-radius', String(finalRadius));
        listContentEl.setAttribute('data-background', background);
        listContentEl.setAttribute('data-border', border);
        listContentEl.setAttribute('data-color-item', colorItem);
        listContentEl.style.setProperty('--col-per-view', String(colPerView));
        listContentEl.style.setProperty('--space-between', `${finalSpace}px`);
        listContentEl.style.setProperty('--border-radius', `${finalRadius}px`);
        listContentEl.style.setProperty('--background', background);
        listContentEl.style.setProperty('--border', border);
        listContentEl.style.setProperty('--color-item', colorItem);
      }
    }

    if (updatedData.listTabNav) {
      const listTabNavEl = container.querySelector('[data-attribute="list-tab-nav"]');
      if (listTabNavEl) {
        listTabNavEl.setAttribute('data-color-tab-nav', updatedData.listTabNav.navColor);
        listTabNavEl.setAttribute('data-background-tab-nav', updatedData.listTabNav.navBackground);
        listTabNavEl.setAttribute('data-border-radius-tab-nav', updatedData.listTabNav.navBorderRadius);
        listTabNavEl.setAttribute('data-active-color-tab-nav', updatedData.listTabNav.activeNavColor);
        listTabNavEl.setAttribute('data-active-background-tab-nav', updatedData.listTabNav.activeNavBackground);
        listTabNavEl.style.setProperty('--color-tab-nav', updatedData.listTabNav.navColor);
        listTabNavEl.style.setProperty('--background-tab-nav', updatedData.listTabNav.navBackground);
        listTabNavEl.style.setProperty('--border-radius-tab-nav', `${updatedData.listTabNav.navBorderRadius}px`);
        listTabNavEl.style.setProperty('--active-color-tab-nav', updatedData.listTabNav.activeNavColor);
        listTabNavEl.style.setProperty('--active-background-tab-nav', updatedData.listTabNav.activeNavBackground);
      }
    }

    if (Array.isArray(updatedData.tabs)) {
      const tabs = updatedData.tabs.map((tab, index) => ({
        key: tab.key || `tab-${index + 1}`,
        label: tab.label || `Tab ${index + 1}`,
        active: !!tab.active,
        reviews: Array.isArray(tab.reviews) ? tab.reviews : [],
      }));
      if (!tabs.some(tab => tab.active) && tabs.length) tabs[0].active = true;

      const listTabNavEl = container.querySelector('[data-attribute="list-tab-nav"]');
      if (listTabNavEl) {
        listTabNavEl.innerHTML = tabs
          .map(
            tab =>
              `<div data-tab="${tab.key}" data-attribute="tab-nav-item" class="tab-nav-item${
                tab.active ? ' active' : ''
              }">${tab.label}</div>`,
          )
          .join('');
      }

      const listTabContentEl = container.querySelector('[data-attribute="list-tab-content"]');
      if (listTabContentEl) {
        listTabContentEl.innerHTML = tabs
          .map(tab => {
            const reviewsHtml = (tab.reviews || [])
              .map(
                review => `
                  <div data-attribute="child-item" class="child-item">
                    <div data-attribute="review" class="review">${review.review || ''}</div>
                    <div class="wrap-user-info">
                      <div data-attribute="avatar" class="avatar">
                        <img src="${review.avatar || ''}" alt="" />
                      </div>
                      <div data-attribute="username" class="username">${review.username || ''}</div>
                      <div data-attribute="verified" data-show="${
                        review.verifiedShow ? 'true' : 'false'
                      }" class="verified" style="${review.verifiedShow ? 'display: flex;' : 'display: none;'};">
                        <img data-attribute="verified-icon" src="${review.verifiedIcon || ''}" alt="" />
                        <span data-attribute="verified-text">${review.verifiedText || ''}</span>
                      </div>
                    </div>
                  </div>
                `,
              )
              .join('');
            return `
              <div data-tab="${tab.key}" data-attribute="tab-content" class="tab-content${tab.active ? ' active' : ''}">
                <div class="wrap-child-item">${reviewsHtml}</div>
              </div>
            `;
          })
          .join('');
      }
    }

    return container.innerHTML.trim();
  },
  sectionCardMultiBoxer(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.titleCard) {
      const titleCardEl = container.querySelector('[data-attribute="card-title"]');
      if (titleCardEl) {
        const show = !!updatedData.titleCard.show;
        titleCardEl.setAttribute('data-show', show ? 'true' : 'false');
        titleCardEl.style.display = show ? '' : 'none';
        titleCardEl.innerHTML = show ? updatedData.titleCard.content || '' : '';
      }
    }

    const listItemEl = container.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      const items = Array.isArray(updatedData.items) ? updatedData.items : [];
      listItemEl.innerHTML = items.map(item => buildMultiBoxerSlideHtml(item)).join('');
    }

    if (updatedData.buttonOutSide) {
      const buttonOutSideEl = container.querySelector('[data-attribute="wrap-btn-dynamic-primary"]');
      if (buttonOutSideEl) {
        updateButtonBasic(buttonOutSideEl, updatedData.buttonOutSide);
      }
    }

    function buildMultiBoxerSlideHtml(item) {
      if (!item) return '';
      const media = item.media || {};
      const content = item.content || {};
      const mediaType = media.type === 'video' ? 'video' : 'image';
      const mediaOrder = Number(media.order) || 1;
      const contentOrder = Number(content.order) || 2;
      const showImg = mediaType === 'image';
      const showVideo = mediaType === 'video';
      const centerY = item.centerY || false;
      const gutter = item.gutter || 30;
      const mediaWidth = item.mediaWidth || 50;
      const useCustomWidthMedia = item.useCustomWidthMedia || false;

      const titleDesc = content.titleDescription || {};
      const titleDescShow = titleDesc.show !== false;

      const survey = content.survey || {};
      const surveyShow = survey.show !== false;
      const surveyColor = survey.colorPercent || '#606F99';
      const surveyTitleHtml = survey.title || '';
      const surveyItems = Array.isArray(survey.items) ? survey.items : [];
      const radius = 40;
      const circumference = 2 * Math.PI * radius;

      const surveyItemsHtml = surveyItems
        .map(s => {
          const percent = Math.max(0, Math.min(100, Number(s.percent) || 0));
          const offset = circumference * (1 - percent / 100);
          return `
                    <div data-attribute="item-survay" class="wrap-survay-item">
                      <div class="left-item">
                        <svg class="size-full" viewBox="0 0 100 100">
                          <circle class="text-gray-300" stroke-width="8" stroke="#D4DCEB" fill="transparent" cx="50" cy="50" r="40"></circle>
                          <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8" fill="transparent" stroke="${surveyColor}" stroke-linecap="butt" transform="rotate(-90 50 50)" stroke-dasharray="${circumference}" stroke-dashoffset="${offset}"></circle>
                        </svg>
                        <div class="wrap-percent" data-attribute="wrap-percent-survay" style="color: ${surveyColor};"><span data-attribute="percent-survay">${percent}</span>%</div>
                      </div>
                      <div data-attribute="description-survay" class="right-item">${s.description || ''}</div>
                    </div>
                  `;
        })
        .join('');

      const accordion = content.accordion || {};
      const accordionShow = accordion.show !== false;
      const accordionItems = Array.isArray(accordion.items) ? accordion.items : [];
      const accordionItemsHtml = accordionItems
        .map(
          a => `
                  <div data-attribute="accordion-item" class="accordion-item">
                    <div data-attribute="accordion-title" class="accordion-title">
                      <div data-attribute="accordion-title-text">${a.title || ''}</div>
                      <div class="accordion-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down">
                          <path d="m6 9 6 6 6-6" />
                        </svg>
                      </div>
                    </div>
                    <div data-attribute="accordion-content" class="accordion-content">
                      <div data-attribute="accordion-text" class="accordion-text">${a.content || ''}</div>
                    </div>
                  </div>
                `,
        )
        .join('');

      const itemsWithIcon = content.itemsWithIcon || {};
      const itemsWithIconShow = itemsWithIcon.show !== false;
      const itemsWithIconItems = Array.isArray(itemsWithIcon.items) ? itemsWithIcon.items : [];
      const itemsWithIconHtml = itemsWithIconItems
        .map(
          it => `
                  <div data-attribute="item-with-icon" class="wrap-item">
                    <div class="wrap-icon">
                      <img data-attribute="icon-with-icon-image" src="${it.icon || ''}" alt="">
                    </div>
                    <div class="wrap-tex-icon">
                      <div data-attribute="title-with-icon" class="title-icon">${it.title || ''}</div>
                      <div data-attribute="description-with-icon" class="description-icon">${it.description || ''}</div>
                    </div>
                  </div>
                `,
        )
        .join('');

      const buttonInnerHtml = content.button ? updateButtonInner(content.button) : '';

      return `
            <div class="swiper-slide">
              <div data-attribute="item" data-center-y="${
                centerY ? 'true' : 'false'
              }" data-gutter="${gutter}" data-media-width="${mediaWidth}" data-use-custom-width-media="${
        useCustomWidthMedia ? 'true' : 'false'
      }" class="wrap-item" style="--gutter: ${gutter}px; --media-width: ${mediaWidth}px;">
                <div data-attribute="media" data-media-type="${mediaType}" data-order="${mediaOrder}" class="wrap-media" style="order: ${mediaOrder};">
                  <div data-show="${showImg ? 'true' : 'false'}" data-attribute="wrap-img" class="wrap-img" style="${
        showImg ? '' : 'display: none;'
      }">
                    <img data-attribute="image-item" src="${media.image || ''}" alt="">
                  </div>
                  <div data-show="${
                    showVideo ? 'true' : 'false'
                  }" data-attribute="wrap-video" class="wrap-video" style="${showVideo ? '' : 'display: none;'}">
                    <video data-attribute="video-item" autoplay loop muted src="${media.video || ''}"></video>
                  </div>
                </div>
                <div data-attribute="content" data-order="${contentOrder}" class="wrap-content" style="order: ${contentOrder};">
                  <div data-show="${
                    titleDescShow ? 'true' : 'false'
                  }" data-attribute="title-description" class="title-description" style="${
        titleDescShow ? '' : 'display: none;'
      }">${titleDescShow ? titleDesc.content || '' : ''}</div>
                  <div data-show="${
                    surveyShow ? 'true' : 'false'
                  }" data-attribute="wrap-survey" data-color-percent="${surveyColor}" class="wrap-survey" style="${
        surveyShow ? '' : 'display: none;'
      }">
                    <div data-attribute="survey-title" class="survey-title">${surveyTitleHtml}</div>
                    <div class="list-survey-item">${surveyItemsHtml}</div>
                  </div>
                  <div data-show="${
                    accordionShow ? 'true' : 'false'
                  }" data-attribute="wrap-accordion" class="wrap-accordion" style="${
        accordionShow ? '' : 'display: none;'
      }">${accordionItemsHtml}</div>
                  <div data-show="${
                    itemsWithIconShow ? 'true' : 'false'
                  }" data-attribute="wrap-item-with-icon" class="wrap-item-with-icon" style="${
        itemsWithIconShow ? '' : 'display: none;'
      }">${itemsWithIconHtml}</div>
      <div data-attribute="wrap-btn-dynamic" class="wrap-btn">
                  ${buttonInnerHtml}
                  </div>
                </div>
              </div>
            </div>
          `;
    }

    return container.innerHTML.trim();
  },

  sectionCardReviewsBoxer(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.titleCard) {
      const titleCardEl = container.querySelector('[data-attribute="card-title"]');
      if (titleCardEl) {
        const show = !!updatedData.titleCard.show;
        titleCardEl.setAttribute('data-show', show ? 'true' : 'false');
        titleCardEl.style.display = show ? '' : 'none';
        titleCardEl.innerHTML = show ? updatedData.titleCard.content || '' : '';
      }
    }

    const list = updatedData.list || {};
    const colorStar = list.colorStar || '#FFD700';
    const colPerView = Number(list.colPerView) || 4;
    const spaceBetween = Number(list.spaceBetween) || 16;
    const items = Array.isArray(list.items) ? list.items : [];

    const listItemEl = container.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      listItemEl.setAttribute('data-color-star', colorStar);
      listItemEl.setAttribute('data-col-per-view', String(colPerView));
      listItemEl.setAttribute('data-space-between', String(spaceBetween));
      listItemEl.style.setProperty('--color-star', colorStar);
      listItemEl.innerHTML = items.map(item => buildReviewsBoxerSlideHtml(item, colorStar)).join('');
    }

    if (updatedData.buttonOutSide) {
      const buttonOutSideEl = container.querySelector('[data-attribute="wrap-btn-dynamic-primary"]');
      if (buttonOutSideEl) {
        updateButtonBasic(buttonOutSideEl, updatedData.buttonOutSide);
      }
    }

    function buildStarsHtml(value, color) {
      const stars = [];
      const v = Math.max(0, Math.min(5, Number(value) || 0));
      for (let i = 0; i < 5; i++) {
        const filled = i < v;
        stars.push(`
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="color: ${filled ? color : '#D9D9D9'};">
                <title>star</title>
                <path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" fill="currentColor" />
              </svg>
            `);
      }
      return stars.join('');
    }

    function buildReviewsBoxerSlideHtml(item, color) {
      if (!item) return '';
      const stars = Math.max(0, Math.min(5, Number(item.stars) || 0));
      const showVerified = item.showVerified !== false;
      return `
            <div class="swiper-slide">
              <div data-attribute="item" class="wrap-item">
                <div class="wrap-img">
                  <img data-attribute="image-item" src="${item.image || ''}" alt="">
                </div>
                <div class="wrap-content-item">
                  <div class="wrap-top-content-item">
                    <div data-attribute="stars-item" data-value="${stars}" class="stars">
                      ${buildStarsHtml(stars, color)}
                    </div>
                    <div data-attribute="comment-item" class="comment-item">${item.comment || ''}</div>
                  </div>
                  <div class="wrap-bottom-content-item">
                    <div data-attribute="reviewer" class="reviewer">${item.reviewer || ''}</div>
                    <div data-attribute="verified" data-show="${
                      showVerified ? 'true' : 'false'
                    }" class="block-verified" style="display: ${showVerified ? 'flex' : 'none'};">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_611_1903)">
                          <path d="M9.9999 2.02539L11.6312 3.83789L13.9874 3.11289L14.5312 5.46914L16.8874 6.01289L16.1624 8.36914L17.9749 10.0004L16.1624 11.6316L16.8874 13.9879L14.5312 14.5316L13.9874 16.8879L11.6312 16.1629L9.9999 17.9754L8.36865 16.1629L6.0124 16.8879L5.46865 14.5316L3.1124 13.9879L3.8374 11.6316L2.0249 10.0004L3.8374 8.36914L3.1124 6.01289L5.46865 5.46914L6.0124 3.11289L8.36865 3.83789L9.9999 2.02539Z" fill="#42ADA4"></path>
                          <path d="M13.8422 6.59375L8.91219 11.5238L6.88219 9.49375L5.86719 10.5087L8.91219 13.5538L14.8572 7.60875L13.8422 6.59375Z" fill="#E3F2FD"></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_611_1903">
                            <rect width="20" height="20" fill="white"></rect>
                          </clipPath>
                        </defs>
                      </svg>
                      <span data-attribute="verified-text">Verified Buyer</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `;
    }

    return container.innerHTML.trim();
  },

  sectionSliderBoxerProduct(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.titleCard) {
      const titleCardEl = container.querySelector('[data-attribute="card-title"]');
      if (titleCardEl) {
        const show = !!updatedData.titleCard.show;
        titleCardEl.setAttribute('data-show', show ? 'true' : 'false');
        titleCardEl.style.display = show ? '' : 'none';
        titleCardEl.innerHTML = show ? updatedData.titleCard.content || '' : '';
      }
    }

    const list = updatedData.list || {};
    const colPerView = Number(list.colPerView) || 3;
    const spaceBetween = Number(list.spaceBetween) || 16;
    const items = Array.isArray(list.items) ? list.items : [];

    const listItemEl = container.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      listItemEl.setAttribute('data-col-per-view', String(colPerView));
      listItemEl.setAttribute('data-space-between', String(spaceBetween));
      listItemEl.innerHTML = items.map(item => buildSliderBoxerProductSlideHtml(item)).join('');
    }

    if (updatedData.buttonOutSide) {
      const buttonOutSideEl = container.querySelector('[data-attribute="wrap-btn-dynamic-primary"]');
      if (buttonOutSideEl) {
        updateButtonBasic(buttonOutSideEl, updatedData.buttonOutSide);
      }
    }

    function buildSliderBoxerProductSlideHtml(item) {
      if (!item) return '';
      const showIconText = item.showIconText !== false;
      return `
            <div class="swiper-slide">
              <a data-attribute="item" href="${item.link || '#'}" class="wrap-item">
                <div class="wrap-img">
                  <img data-attribute="image-item" src="${item.image || ''}" alt="">
                </div>
                <div class="wrap-content-item">
                  <div data-attribute="product-name" class="product-name">${item.name || ''}</div>
                  <div class="wrap-ct-bot">
                    <div data-attribute="product-price" class="product-price">
                      <div data-attribute="from-text" class="from-text">${item.fromText || ''}</div>
                      <div data-attribute="price-new" class="price-new">${item.priceNew || ''}</div>
                      <div data-attribute="price-old" class="price-old">${item.priceOld || ''}</div>
                      <div data-attribute="state-product" class="state-product">${item.stateProduct || ''}</div>
                    </div>
                    <div data-attribute="icon-with-text" data-show="${
                      showIconText ? 'true' : 'false'
                    }" class="wrap-icon-with-text" style="display: ${showIconText ? 'flex' : 'none'};">
                      <div class="wrap-icon">
                        <img data-attribute="icon-item" src="${item.icon || ''}" alt="">
                      </div>
                      <div data-attribute="text-item" class="wrap-text">${item.iconText || ''}</div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          `;
    }

    return container.innerHTML.trim();
  },
  sectionImageWithTextConvenFeet01(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const layout = updatedData.layout || {};
    const wrapCard = container.querySelector('[data-attribute="wrap-card"]');
    if (wrapCard) {
      const centerY = layout.centerY !== false;
      const gapItem = Number(layout.gapItem);
      const finalGap = Number.isFinite(gapItem) ? gapItem : 112;
      wrapCard.setAttribute('data-center-y', centerY ? 'true' : 'false');
      wrapCard.setAttribute('data-gap-item', String(finalGap));
      wrapCard.style.setProperty('--gap-item', `${finalGap}px`);
    }

    const contentOrder = Number(layout.contentOrder) === 2 ? 2 : 1;
    const imagesOrder = contentOrder === 1 ? 2 : 1;

    const wrapContent = container.querySelector('[data-attribute="wrap-content"]');
    if (wrapContent) {
      wrapContent.setAttribute('data-order', String(contentOrder));
      wrapContent.style.setProperty('--order-content', String(contentOrder));
    }

    const wrapImages = container.querySelector('[data-attribute="wrap-images"]');
    if (wrapImages) {
      wrapImages.setAttribute('data-order', String(imagesOrder));
      wrapImages.style.setProperty('--order-images', String(imagesOrder));
      const borderImage = Number(layout.borderImage);
      const finalBorder = Number.isFinite(borderImage) ? borderImage : 10;
      const borderColor = layout.borderColorImage || '#006196';
      wrapImages.setAttribute('data-border-image', String(finalBorder));
      wrapImages.setAttribute('data-border-color-image', borderColor);
      wrapImages.style.setProperty('--border-image', `${finalBorder}px`);
      wrapImages.style.setProperty('--border-color-image', borderColor);
    }

    const wrapTitle = container.querySelector('[data-attribute="wrap-title"]');
    if (wrapTitle) {
      wrapTitle.innerHTML = updatedData.titleContent || '';
    }

    const btnEl = container.querySelector('[data-attribute="wrap-btn-cta"]');
    if (btnEl && updatedData.button) {
      updateButtonBasic(btnEl, updatedData.button);
    }

    const signatureEl = container.querySelector('[data-attribute="signature-image"]');
    if (signatureEl && updatedData.signature) {
      const show = updatedData.signature.show !== false;
      signatureEl.setAttribute('data-show', show ? 'true' : 'false');
      signatureEl.style.display = show ? '' : 'none';
      const img = signatureEl.querySelector('img');
      if (img) {
        img.setAttribute('src', updatedData.signature.image || '');
      }
    }

    const blockImages = container.querySelector('[data-attribute="block-images"]');
    if (blockImages) {
      const items = (updatedData.images || []).slice(0, 3);
      blockImages.innerHTML = items
        .map(
          item => `
        <div class="wrap-image">
          <img data-attribute="image-item" src="${item.image || ''}" alt="">
        </div>
      `,
        )
        .join('');
    }

    return container.innerHTML.trim();
  },
  sectionImageWithTextConvenFeet02(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const layout = updatedData.layout || {};
    const wrapCard = container.querySelector('[data-attribute="wrap-card"]');
    if (wrapCard) {
      const centerY = layout.centerY !== false;
      const gapItem = Number(layout.gapItem);
      const finalGap = Number.isFinite(gapItem) ? gapItem : 60;
      wrapCard.setAttribute('data-center-y', centerY ? 'true' : 'false');
      wrapCard.setAttribute('data-gap-item', String(finalGap));
      wrapCard.style.setProperty('--gap-item', `${finalGap}px`);
    }

    const contentOrder = Number(layout.contentOrder) === 2 ? 2 : 1;
    const imageOrder = contentOrder === 1 ? 2 : 1;

    const wrapContent = container.querySelector('[data-attribute="wrap-content"]');
    if (wrapContent) {
      wrapContent.setAttribute('data-order', String(contentOrder));
      wrapContent.style.setProperty('--order-content', String(contentOrder));
    }

    const wrapImageEl = container.querySelector('[data-attribute="wrap-image"]');
    if (wrapImageEl) {
      wrapImageEl.setAttribute('data-order', String(imageOrder));
      wrapImageEl.style.setProperty('--order-image', String(imageOrder));
      const imgEl = wrapImageEl.querySelector('[data-attribute="image-item"]');
      if (imgEl && updatedData.media) {
        imgEl.setAttribute('src', updatedData.media.image || '');
      }
    }

    const renderStars = value => {
      const count = Number.isFinite(Number(value)) ? Math.max(0, Math.min(5, Number(value))) : 4;
      return Array.from({ length: count })
        .map(
          () => `<svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.7415 0L18.2214 10.7102H29.4828L20.3722 17.3295L23.8521 28.0398L14.7415 21.4205L5.63078 28.0398L9.11075 17.3295L7.9155e-05 10.7102H11.2615L14.7415 0Z" fill="#FFCC00" />
          </svg>`,
        )
        .join('');
    };

    const rateCard = updatedData.rateCard || {};
    const rateCardEl = container.querySelector('[data-attribute="wrap-rate-card"]');
    if (rateCardEl) {
      const show = rateCard.show !== false;
      rateCardEl.setAttribute('data-show', show ? 'true' : 'false');
      rateCardEl.style.display = show ? '' : 'none';
      const starsEl = rateCardEl.querySelector('[data-attribute="wrap-stars"]');
      if (starsEl) {
        const stars = Number(rateCard.stars);
        const finalStars = Number.isFinite(stars) ? Math.max(0, Math.min(5, stars)) : 4;
        starsEl.setAttribute('data-value', String(finalStars));
        starsEl.innerHTML = renderStars(finalStars);
      }
      const ratingTextEl = rateCardEl.querySelector('[data-attribute="wrap-rating-text"]');
      if (ratingTextEl) {
        ratingTextEl.innerHTML = `<span>${rateCard.text || ''}</span>`;
      }
    }

    const titleBlock = updatedData.titleBlock || {};
    const titleEl = container.querySelector('[data-attribute="wrap-title"]');
    if (titleEl) {
      const show = titleBlock.show !== false;
      titleEl.setAttribute('data-show', show ? 'true' : 'false');
      titleEl.style.display = show ? '' : 'none';
      titleEl.innerHTML = show ? titleBlock.content || '' : '';
    }

    const policyItems = updatedData.policyItems || {};
    const policyEl = container.querySelector('[data-attribute="policy-items"]');
    if (policyEl) {
      const show = policyItems.show !== false;
      const color = policyItems.color || '#006196';
      const background = policyItems.background || '#F2F7F9';
      policyEl.setAttribute('data-show', show ? 'true' : 'false');
      policyEl.setAttribute('data-color-policy-item', color);
      policyEl.setAttribute('data-background-policy-item', background);
      policyEl.style.display = show ? '' : 'none';
      policyEl.style.setProperty('--color-policy-item', color);
      policyEl.style.setProperty('--background-policy-item', background);
      policyEl.innerHTML = (policyItems.items || [])
        .map(
          item => `
        <div data-attribute="policy-item-content" class="policy-item-content">
          <img data-attribute="icon-image" src="${item.icon || ''}" alt="">
          <span data-attribute="policy-text">${item.text || ''}</span>
        </div>
      `,
        )
        .join('');
    }

    const description = updatedData.description || {};
    const descriptionEl = container.querySelector('[data-attribute="description-card"]');
    if (descriptionEl) {
      const show = description.show !== false;
      descriptionEl.setAttribute('data-show', show ? 'true' : 'false');
      descriptionEl.style.display = show ? '' : 'none';
      descriptionEl.innerHTML = show ? description.content || '' : '';
    }

    const btnEl = container.querySelector('[data-attribute="wrap-btn-cta"]');
    if (btnEl && updatedData.button) {
      updateButtonBasic(btnEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },
  sectionImageWithTextConvenFeet03(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const layout = updatedData.layout || {};
    const wrapCard = container.querySelector('[data-attribute="wrap-card"]');
    if (wrapCard) {
      const centerY = layout.centerY !== false;
      const gapItem = Number(layout.gapItem);
      const finalGap = Number.isFinite(gapItem) ? gapItem : 60;
      wrapCard.setAttribute('data-center-y', centerY ? 'true' : 'false');
      wrapCard.setAttribute('data-gap-item', String(finalGap));
      wrapCard.style.setProperty('--gap-item', `${finalGap}px`);
    }

    const contentOrder = Number(layout.contentOrder) === 2 ? 2 : 1;
    const imageOrder = contentOrder === 1 ? 2 : 1;

    const wrapContent = container.querySelector('[data-attribute="wrap-content"]');
    if (wrapContent) {
      const backgroundContent = layout.backgroundContent || '#F2F7F9';
      wrapContent.setAttribute('data-order', String(contentOrder));
      wrapContent.setAttribute('data-background-content', backgroundContent);
      wrapContent.style.setProperty('--order-content', String(contentOrder));
      wrapContent.style.setProperty('--background-content', backgroundContent);
    }

    const wrapImageEl = container.querySelector('[data-attribute="wrap-image"]');
    if (wrapImageEl) {
      wrapImageEl.setAttribute('data-order', String(imageOrder));
      wrapImageEl.style.setProperty('--order-image', String(imageOrder));
      const imgEl = wrapImageEl.querySelector('[data-attribute="image-item"]');
      if (imgEl && updatedData.media) {
        imgEl.setAttribute('src', updatedData.media.image || '');
      }
    }

    const titleBlock = updatedData.titleBlock || {};
    const titleEl = container.querySelector('[data-attribute="wrap-title"]');
    if (titleEl) {
      const show = titleBlock.show !== false;
      titleEl.setAttribute('data-show', show ? 'true' : 'false');
      titleEl.style.display = show ? '' : 'none';
      titleEl.innerHTML = show ? titleBlock.content || '' : '';
    }

    const blockIconEl = container.querySelector('[data-attribute="block-icon-with-text"]');
    if (blockIconEl) {
      blockIconEl.innerHTML = (updatedData.iconItems || [])
        .map(
          item => `
        <div data-attribute="item-icon-with-text" class="item-icon-with-text">
          <div class="wrap-icon">
            <img data-attribute="icon-item" src="${item.icon || ''}" alt="">
          </div>
          <div data-attribute="wrap-text" class="wrap-text">
            ${item.content || ''}
          </div>
        </div>
      `,
        )
        .join('');
    }

    return container.innerHTML.trim();
  },
  sectionIconGridWithHeroTextConvenFeet(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl && updatedData.cardTitle) {
      cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
    }

    const listItem = updatedData.listItem || {};
    const listItemEl = container.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      const colPerView = Number(listItem.colPerView) || 4;
      const bgColorItem = listItem.bgColorItem || '#006196';
      const borderColorItem = listItem.borderColorItem || '#006196';

      listItemEl.setAttribute('data-col-perview', String(colPerView));
      listItemEl.setAttribute('data-bg-color-item', bgColorItem);
      listItemEl.setAttribute('data-border-color-item', borderColorItem);
      listItemEl.style.setProperty('--col-perview', String(colPerView));
      listItemEl.style.setProperty('--bg-color-item', bgColorItem);
      listItemEl.style.setProperty('--border-color-item', borderColorItem);

      listItemEl.innerHTML = (updatedData.items || [])
        .map(
          item => `
        <div data-attribute="icon-twc" class="item-twc">
          <div class="wrap-img">
            <img data-attribute="image-item" src="${item.image || ''}" alt="">
          </div>
          <div data-attribute="content-item" class="content-item">
            ${item.content || ''}
          </div>
        </div>
      `,
        )
        .join('');
    }

    return container.innerHTML.trim();
  },
  sectionCalyrafitBanner(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const media = updatedData.media || {};
    const useVideo = media.useVideo !== false;

    const wrapMedia = container.querySelector('[data-attribute="wrap-media"]');
    if (wrapMedia) {
      wrapMedia.setAttribute('data-use-vid', useVideo ? 'true' : 'false');
    }

    const wrapVideoBanner = container.querySelector('[data-attribute="wrap-video-banner"]');
    if (wrapVideoBanner) {
      wrapVideoBanner.style.display = useVideo ? '' : 'none';
    }

    const wrapImageBanner = container.querySelector('[data-attribute="wrap-image-banner"]');
    if (wrapImageBanner) {
      wrapImageBanner.style.display = useVideo ? 'none' : '';
    }

    const videoEl = container.querySelector('[data-attribute="video-banner"]');
    if (videoEl) {
      videoEl.setAttribute('src', media.videoSrc || '');
    }

    const imageEl = container.querySelector('[data-attribute="image-banner"]');
    if (imageEl) {
      imageEl.setAttribute('src', media.image || '');
    }

    const highlights = updatedData.highlights || {};
    const wrapHighlights = container.querySelector('[data-attribute="wrap-highlights"]');
    if (wrapHighlights) {
      const show = highlights.show !== false;
      wrapHighlights.setAttribute('data-show', show ? 'true' : 'false');
      wrapHighlights.style.display = show ? '' : 'none';

      const colPerViewNum = Number(highlights.colPerView);
      const colPerView = Number.isFinite(colPerViewNum) && colPerViewNum > 0 ? colPerViewNum : 4;
      wrapHighlights.setAttribute('col-per-view', String(colPerView));
      wrapHighlights.style.setProperty('--col-per-view', String(colPerView));

      wrapHighlights.innerHTML = (highlights.items || [])
        .map(
          item => `
        <div data-attribute="item-highlight" class="item-highlight">
          ${item.content || ''}
        </div>
      `,
        )
        .join('');
    }

    return container.innerHTML.trim();
  },
  sectionCalyrafitMarquee01(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const blockMarquee = container.querySelector('[data-attribute="block-marquee"]');
    if (blockMarquee) {
      const speedNum = Number(updatedData.speed);
      const speed = Number.isFinite(speedNum) && speedNum > 0 ? speedNum : 25;
      blockMarquee.setAttribute('data-speed', String(speed));
      blockMarquee.style.setProperty('--speed', `${speed}s`);
    }

    const listItem = container.querySelector('[data-attribute="list-item"]');
    if (listItem) {
      const items = updatedData.items || [];
      listItem.innerHTML = items
        .map(
          item => `
        <div data-attribute="item" class="item-marquee">
          <a href="${item.link || '#'}" data-attribute="link-item" target="_blank" class="wrap-item">
            <div class="wrap-img">
              <img data-attribute="image-item" src="${item.image || ''}" alt="">
            </div>
          </a>
        </div>
      `,
        )
        .join('');
    }

    return container.innerHTML.trim();
  },
  sectionCalyrafitMarquee(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const cardTitle = updatedData.cardTitle || {};
    const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      const show = cardTitle.show !== false;
      cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
      cardTitleEl.style.display = show ? '' : 'none';
      cardTitleEl.innerHTML = cardTitle.content || '';
    }

    const blockMarquee = container.querySelector('[data-attribute="block-marquee"]');
    if (blockMarquee) {
      const speedNum = Number(updatedData.speed);
      const speed = Number.isFinite(speedNum) && speedNum > 0 ? speedNum : 25;
      blockMarquee.setAttribute('data-speed', String(speed));
      blockMarquee.style.setProperty('--speed', `${speed}s`);

      const itemGapNum = Number(updatedData.itemGap);
      const itemGap = Number.isFinite(itemGapNum) && itemGapNum >= 0 ? itemGapNum : 30;
      blockMarquee.setAttribute('data-item-gap', String(itemGap));
      blockMarquee.style.setProperty('--item-gap', `${itemGap}px`);

      const itemWidthNum = Number(updatedData.itemWidth);
      const itemWidth = Number.isFinite(itemWidthNum) && itemWidthNum > 0 ? itemWidthNum : 270;
      blockMarquee.setAttribute('data-item-width', String(itemWidth));
      blockMarquee.style.setProperty('--item-width', `${itemWidth}px`);
    }

    const listItem = container.querySelector('[data-attribute="list-item"]');
    if (listItem) {
      const items = updatedData.items || [];
      listItem.innerHTML = items
        .map(
          item => `
        <div data-attribute="item" class="item-marquee">
          <div data-attribute="link-item" class="wrap-item">
            <div class="wrap-img">
              <img data-attribute="image-item" src="${item.image || ''}" alt="">
            </div>
          </div>
        </div>
      `,
        )
        .join('');
    }

    return container.innerHTML.trim();
  },
  sectionCalyrafitGirdImage(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const mainImage = updatedData.mainImage || {};
    const wrapMainImage = container.querySelector('[data-attribute="wrap-main-image"]');
    if (wrapMainImage) {
      wrapMainImage.setAttribute('href', mainImage.link || '#');
    }

    const imageMainEl = container.querySelector('[data-attribute="image-main"]');
    if (imageMainEl) {
      imageMainEl.setAttribute('src', mainImage.image || '');
    }

    // group-img-second là danh sách CỐ ĐỊNH số lượng: chỉ set lại thuộc tính trên các item
    // đã có sẵn trong markup, không rebuild/innerHTML lại danh sách -> không thể add/remove item.
    const groupImgSecond = container.querySelector('[data-attribute="group-img-second"]');
    if (groupImgSecond) {
      const secondImages = updatedData.secondImages || [];
      const itemEls = groupImgSecond.querySelectorAll('[data-attribute="wrap-img-item"]');
      itemEls.forEach((itemEl, index) => {
        const data = secondImages[index] || {};
        itemEl.setAttribute('href', data.link || '');
        const imageEl = itemEl.querySelector('[data-attribute="image-second"]');
        if (imageEl) {
          imageEl.setAttribute('src', data.image || '');
        }
      });
    }

    return container.innerHTML.trim();
  },
  sectionCalyrafitBestSaller(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const cardTitle = updatedData.cardTitle || {};
    const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      const show = cardTitle.show !== false;
      cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
      cardTitleEl.style.display = show ? '' : 'none';
      cardTitleEl.innerHTML = cardTitle.content || '';
    }

    const highlightColor = updatedData.highlightColor || '#AD4870';
    const showActions = updatedData.showActions !== false;
    const bodyProductsEl = container.querySelector('[data-attribute="body-products"]');
    if (bodyProductsEl) {
      bodyProductsEl.setAttribute('data-highlight-color', highlightColor);
      bodyProductsEl.style.setProperty('--highlight-color', highlightColor);
      bodyProductsEl.setAttribute('data-show-actions', showActions ? 'true' : 'false');
    }

    const products = Array.isArray(updatedData.products) ? updatedData.products : [];
    const productsHtml = products.map(product => buildCalyrafitBestSallerProductHtml(product)).join('');

    const desktopEl = container.querySelector('[data-attribute="gird-products-desktop"]');
    if (desktopEl) {
      desktopEl.innerHTML = productsHtml;
    }

    const swiperWrapperEl = container.querySelector('[data-attribute="swiper-wrapper"]');
    if (swiperWrapperEl) {
      swiperWrapperEl.innerHTML = products
        .map(product => `<div class="swiper-slide">${buildCalyrafitBestSallerProductHtml(product)}</div>`)
        .join('');
    }

    if (updatedData.buttonOutSide) {
      const buttonOutSideEl = container.querySelector('[data-attribute="wrap-btn-dynamic-primary"]');
      if (buttonOutSideEl) {
        updateButtonBasic(buttonOutSideEl, updatedData.buttonOutSide);
      }
    }

    function buildCalyrafitBestSallerProductHtml(product) {
      if (!product) return '';
      const state = product.state || {};
      const showState = state.show !== false;
      const images = Array.isArray(product.images) && product.images.length ? product.images : [''];

      return `
      <a href="${product.link || '#'}" data-attribute="item-product" class="item-product">
        <div class="group-images">
          <div class="wrap-images" data-attribute="wrap-images">
            ${images.map(image => `<img data-attribute="item-image" src="${image || ''}" alt="" />`).join('')}
          </div>
          <div
            class="state"
            data-attribute="state"
            data-show="${showState ? 'true' : 'false'}"
            style="display: ${showState ? '' : 'none'};"
          >
            ${state.text || ''}
          </div>
        </div>
        <div class="item-info" data-attribute="item-info">
          <div class="title-item" data-attribute="title-item">
            ${product.title || ''}
          </div>
          <div class="block-price-cart">
            <div class="block-price">
              <span data-attribute="price" class="price">${product.price || ''}</span>
              <span data-attribute="old-price" class="old-price">${product.oldPrice || ''}</span>
            </div>
            ${
              showActions
                ? `
            <div class="block-view-cart">
              <div class="view-product icon-product">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M21 12C21 13.2 16.97 18 12 18C7.03 18 3 13.2 3 12C3 10.8 7.03 6 12 6C16.97 6 21 10.8 21 12Z"
                    stroke="white"
                    stroke-width="1.5"
                  />
                  <path
                    d="M15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12Z"
                    stroke="white"
                    stroke-width="1.5"
                  />
                </svg>
              </div>
              <div class="cart icon-product">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5 4H6.5L9 16M9 16C8.46957 16 7.96086 16.2107 7.58579 16.5858C7.21071 16.9609 7 17.4696 7 18C7 18.5304 7.21071 19.0391 7.58579 19.4142C7.96086 19.7893 8.46957 20 9 20C9.53043 20 10.0391 19.7893 10.4142 19.4142C10.7893 19.0391 11 18.5304 11 18C11 17.4696 10.7893 16.9609 10.4142 16.5858C10.0391 16.2107 9.53043 16 9 16H17M17 16C16.4696 16 15.9609 16.2107 15.5858 16.5858C15.2107 16.9609 15 17.4696 15 18C15 18.5304 15.2107 19.0391 15.5858 19.4142C15.9609 19.7893 16.4696 20 17 20C17.5304 20 18.0391 19.7893 18.4142 19.4142C18.7893 19.0391 19 18.5304 19 18C19 17.4696 18.7893 16.9609 18.4142 16.5858C18.0391 16.2107 17.5304 16 17 16ZM8.5 13H17.75L19 7H18M8 7H7.312M13 5V9M11 7H15"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            `
                : ''
            }
          </div>
        </div>
      </a>
    `;
    }

    return container.innerHTML.trim();
  },
  sectionCalyrafitSideBySide(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const media = updatedData.media || {};
    const leftCardEl = container.querySelector('[data-attribute="left-card"]');
    if (leftCardEl) {
      const order = media.order === 2 ? 2 : 1;
      leftCardEl.setAttribute('data-order', String(order));
      leftCardEl.style.setProperty('--left-order', String(order));

      const useCustomWidth = media.useCustomWidth !== false;
      leftCardEl.setAttribute('data-use-custom-width', useCustomWidth ? 'true' : 'false');
      const customWidthNum = Number(media.customWidth);
      const customWidth = Number.isFinite(customWidthNum) && customWidthNum > 0 ? customWidthNum : 585;
      leftCardEl.setAttribute('data-custom-width', String(customWidth));
      leftCardEl.style.setProperty('--custom-width', `${customWidth}px`);

      const useVideo = media.useVideo !== false;
      leftCardEl.setAttribute('data-use-vid', useVideo ? 'true' : 'false');
    }

    // Chỉ giữ lại đúng 1 tag media trong DOM (video hoặc img) theo lựa chọn của người dùng -
    // rebuild hẳn nội dung .wrap-media thay vì ẩn/hiện bằng display, để tag không dùng tới
    // (và request mạng/video buffer ẩn phía sau) bị loại khỏi DOM hoàn toàn.
    const useVideo = media.useVideo !== false;
    const wrapMediaEl = container.querySelector('[data-attribute="left-card"] .wrap-media');
    if (wrapMediaEl) {
      wrapMediaEl.innerHTML = useVideo
        ? `<video
            data-attribute="video-left"
            src="${media.videoSrc || ''}"
            autoplay
            loop
            muted
            playsinline
            style="display: block;"
          ></video>`
        : `<img data-attribute="img-left" src="${media.image || ''}" alt="" style="display: block;" />`;
    }

    const content = updatedData.content || {};
    const rightCardEl = container.querySelector('[data-attribute="right-card"]');
    if (rightCardEl) {
      const order = content.order === 1 ? 1 : 2;
      rightCardEl.setAttribute('data-order', String(order));
      rightCardEl.style.setProperty('--right-order', String(order));

      const bgColor = content.bgColor || '#FFD0DB';
      rightCardEl.setAttribute('data-bg-content', bgColor);
      rightCardEl.style.setProperty('--bg-content', bgColor);
    }

    const heading = updatedData.heading || {};
    const headingEl = container.querySelector('[data-attribute="heading-content"]');
    if (headingEl) {
      const show = heading.show !== false;
      headingEl.setAttribute('data-show', show ? 'true' : 'false');
      headingEl.style.display = show ? '' : 'none';
      headingEl.innerHTML = heading.content || '';
    }

    const stats = updatedData.stats || {};
    const statsGroupEl = container.querySelector('[data-attribute="stats-group"]');
    if (statsGroupEl) {
      const show = stats.show !== false;
      statsGroupEl.setAttribute('data-show', show ? 'true' : 'false');
      statsGroupEl.style.display = show ? '' : 'none';

      const bgColor = stats.bgColor || '#ffffff';
      statsGroupEl.setAttribute('data-bg-stats-group', bgColor);
      statsGroupEl.style.setProperty('--bg-stats-group', bgColor);

      const borderColor = stats.borderColor || '#FFD0DB';
      statsGroupEl.setAttribute('data-color-border', borderColor);
      statsGroupEl.style.setProperty('--color-border', borderColor);

      const statsItems = Array.isArray(stats.items) ? stats.items : [];
      statsGroupEl.innerHTML = statsItems
        .map(
          item => `
        <div class="stats-group-item" data-attribute="stats-group-item">${item.content || ''}</div>
      `,
        )
        .join('');
    }

    const pills = updatedData.pills || {};
    const listPillEl = container.querySelector('[data-attribute="list-pill"]');
    if (listPillEl) {
      const show = pills.show !== false;
      listPillEl.setAttribute('data-show', show ? 'true' : 'false');
      listPillEl.style.display = show ? '' : 'none';

      const bgColor = pills.bgColor || '#ffffff';
      listPillEl.setAttribute('data-bg-pill', bgColor);
      listPillEl.style.setProperty('--bg-pill', bgColor);

      const borderColor = pills.borderColor || '#FFD0DB';
      listPillEl.setAttribute('data-color-border', borderColor);
      listPillEl.style.setProperty('--color-border', borderColor);

      const pillItems = Array.isArray(pills.items) ? pills.items : [];
      listPillEl.innerHTML = pillItems
        .map(
          item => `
        <div class="pill-item" data-attribute="pill-item">${item.text || ''}</div>
      `,
        )
        .join('');
    }

    const featureCallout = updatedData.featureCallout || {};
    const featureCalloutEl = container.querySelector('[data-attribute="feature-callout"]');
    if (featureCalloutEl) {
      const show = featureCallout.show !== false;
      featureCalloutEl.setAttribute('data-show', show ? 'true' : 'false');
      featureCalloutEl.style.display = show ? '' : 'none';

      const colorLine = featureCallout.colorLine || '#AD4870';
      featureCalloutEl.setAttribute('data-color-line', colorLine);
      featureCalloutEl.style.setProperty('--color-line', colorLine);

      featureCalloutEl.innerHTML = featureCallout.content || '';
    }

    const testimonial = updatedData.testimonial || {};
    const testimonialEl = container.querySelector('[data-attribute="testimonial"]');
    if (testimonialEl) {
      const show = testimonial.show !== false;
      testimonialEl.setAttribute('data-show', show ? 'true' : 'false');
      testimonialEl.style.display = show ? '' : 'none';

      const colorHighlight = testimonial.colorHighlight || '#FFD0DB';
      testimonialEl.setAttribute('data-color-highlight', colorHighlight);
      testimonialEl.style.setProperty('--color-highlight', colorHighlight);
    }

    const avatarEl = container.querySelector('[data-attribute="avatar-expert"]');
    if (avatarEl) {
      avatarEl.setAttribute('src', testimonial.avatar || '');
    }

    const testimonialContentEl = container.querySelector('[data-attribute="testimonial-content"]');
    if (testimonialContentEl) {
      testimonialContentEl.innerHTML = testimonial.content || '';
    }

    if (updatedData.button) {
      const btnEl = container.querySelector('[data-attribute="wrap-btn-dynamic"]');
      if (btnEl) {
        updateButtonBasic(btnEl, updatedData.button);
      }
    }

    return container.innerHTML.trim();
  },
  sectionCalyrafitSlide(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const cardTitle = updatedData.cardTitle || {};
    const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      const show = cardTitle.show !== false;
      cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
      cardTitleEl.style.display = show ? '' : 'none';
      cardTitleEl.innerHTML = cardTitle.content || '';
    }

    const items = Array.isArray(updatedData.items) ? updatedData.items : [];
    const listItemEl = container.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      listItemEl.innerHTML = items.map(item => buildCalyrafitSlideItemHtml(item)).join('');
    }

    return container.innerHTML.trim();

    // Icon CTA tuỳ chọn: item.cta.icon rỗng (người dùng bấm xoá ảnh trong UploadImage) -> bỏ hẳn
    // tag <img data-attribute="icon-cta"> khỏi DOM thay vì ẩn bằng display, đúng note của người dùng.
    function buildCalyrafitSlideItemHtml(item) {
      if (!item) return '';
      const cta = item.cta || {};
      return `
      <div data-attribute="slide-item" class="swiper-slide">
        <div class="wrap-item">
          <div class="wrap-imge">
            <img data-attribute="item-image" src="${item.image || ''}" alt="" />
          </div>
          <div class="wrap-action-info">
            <div class="wrap-title">
              <div data-attribute="sub-title-item" class="sub-title-item">${item.subTitle || ''}</div>
              <div data-attribute="title-item" class="title-item">${item.title || ''}</div>
            </div>
            <div class="wrap-cta">
              <a href="${cta.link || '#'}" data-attribute="cta-item" class="cta-item">
                <span class="text-cta" data-attribute="text-cta">${cta.text || ''}</span>
                ${cta.icon ? `<img data-attribute="icon-cta" src="${cta.icon}" alt="" />` : ''}
              </a>
            </div>
          </div>
        </div>
      </div>
    `;
    }
  },
  sectionCalyrafitCollections(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const cardTitle = updatedData.cardTitle || {};
    const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
    if (cardTitleEl) {
      const show = cardTitle.show !== false;
      cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
      cardTitleEl.style.display = show ? '' : 'none';
      cardTitleEl.innerHTML = cardTitle.content || '';
    }

    const items = Array.isArray(updatedData.items) ? updatedData.items : [];
    const listItemEl = container.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      listItemEl.innerHTML = items.map(item => buildCalyrafitCollectionsItemHtml(item)).join('');
    }

    if (updatedData.button) {
      const btnEl = container.querySelector('[data-attribute="wrap-btn-dynamic-primary"]');
      if (btnEl) {
        updateButtonBasic(btnEl, updatedData.button);
      }
    }

    return container.innerHTML.trim();

    function buildCalyrafitCollectionsItemHtml(item) {
      if (!item) return '';
      return `
      <div class="swiper-slide">
        <a href="${item.link || '#'}" data-attribute="item" class="item-collections">
          <div class="wrap-iamge">
            <img data-attribute="image-item" src="${item.image || ''}" alt="" />
          </div>
          <div data-attribute="title" class="title-collections">${item.content || ''}</div>
        </a>
      </div>
    `;
    }
  },
  sectionCalyrafitTextWithIcon(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const listItemEl = container.querySelector('[data-attribute="list-item"]');
    if (listItemEl) {
      const bgWrapper = updatedData.bgWrapper || listItemEl.getAttribute('data-bg-wrapper') || '#FCF8F9';
      const colorDevider = updatedData.colorDevider || listItemEl.getAttribute('data-color-devider') || '#FFD0DB';

      listItemEl.setAttribute('data-bg-wrapper', bgWrapper);
      listItemEl.setAttribute('data-color-devider', colorDevider);
      listItemEl.style.setProperty('--bg-wrapper', bgWrapper);
      listItemEl.style.setProperty('--color-devider', colorDevider);

      const items = Array.isArray(updatedData.items) ? updatedData.items : [];
      listItemEl.innerHTML = items
        .map(
          item => `
        <div data-attribute="item-text-with-icon" class="item-text-with-icon">
          <div class="wrap-icon">
            <img data-attribute="icon-item" src="${item.icon || ''}" alt="" />
          </div>
          <div data-attribute="text-item" class="text-item">
            ${item.content || ''}
          </div>
        </div>
      `,
        )
        .join('');
    }

    return container.innerHTML.trim();
  },
  sectionCalyrafitReview(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const list = updatedData.list || {};
    const colorStar = list.colorStar || '#EF5A7B';
    const colPerView = Number(list.colPerView) || 3;
    const spaceBetween = Number(list.spaceBetween) || 24;
    const items = Array.isArray(list.items) ? list.items : [];

    const starPath =
      'M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z';

    function buildStarsHtml(value) {
      const count = Math.max(0, Math.min(5, Number(value) || 0));
      const stars = [];
      for (let i = 0; i < count; i++) {
        stars.push(`
          <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="${starPath}" fill="currentColor" />
          </svg>
        `);
      }
      return stars.join('');
    }

    function buildReviewSlideHtml(item) {
      if (!item) return '';
      const stars = Math.max(0, Math.min(5, Number(item.stars) || 0));
      const showVerified = item.showVerified !== false;
      return `
        <div class="swiper-slide">
          <div class="item-review" data-attribute="item-review">
            <div class="wrap-stars" data-star="${stars}" data-attribute="wrap-stars">
              ${buildStarsHtml(stars)}
            </div>
            <div class="review-content" data-attribute="review-content">
              ${item.content || ''}
            </div>
            <div class="reviewer" data-attribute="reviewer">
              <div class="wrap-avatar">
                <img data-attribute="avatar-reviewer" src="${item.avatar || ''}" alt="" />
              </div>
              <div class="wrap-text">
                <div class="name-reviewer" data-attribute="name-reviewer">${item.name || ''}</div>
                <div
                  class="verified-buyer"
                  data-attribute="verified-buyer"
                  data-show="${showVerified ? 'true' : 'false'}"
                  style="display: ${showVerified ? 'flex' : 'none'};"
                >
                  <div class="wrap-icon-verified">
                    <img data-attribute="icon-verified" src="${item.verifiedIcon || ''}" alt="" />
                  </div>
                  <div class="text-verified" data-attribute="text-verified">${item.verifiedText ||
                    'Verified Buyer'}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
    }

    const listEl = container.querySelector('[data-attribute="list-review"]');
    if (listEl) {
      listEl.setAttribute('data-color-star', colorStar);
      listEl.setAttribute('data-col-per-view', String(colPerView));
      listEl.setAttribute('data-space-between', String(spaceBetween));
      listEl.style.setProperty('--color-star', colorStar);

      const wrapperEl = listEl.querySelector('.swiper-wrapper');
      const slidesHtml = items.map(item => buildReviewSlideHtml(item)).join('');
      if (wrapperEl) {
        wrapperEl.innerHTML = slidesHtml;
      } else {
        listEl.innerHTML = `<div class="swiper-wrapper">${slidesHtml}</div>`;
      }
    }

    return container.innerHTML.trim();
  },
  sectionCalyrafitFooter(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const logoEl = container.querySelector('[data-attribute="logo-footer"]');
    if (logoEl) logoEl.setAttribute('src', updatedData.logo || '');

    const addressEl = container.querySelector('[data-attribute="address-store"]');
    if (addressEl) addressEl.textContent = updatedData.addressText || '';

    const emailItems = Array.isArray(updatedData.emailItems) ? updatedData.emailItems : [];
    const emailListEl = container.querySelector('[data-attribute="list-item-company-info"]');
    if (emailListEl) {
      emailListEl.innerHTML = emailItems
        .map(
          item =>
            `<a href="${item.link || ''}" data-attribute="item-company-info" class="item-child">${item.text || ''}</a>`,
        )
        .join('');
    }

    const socialItems = Array.isArray(updatedData.socialItems) ? updatedData.socialItems : [];
    const socialListEl = container.querySelector('[data-attribute="list-item-social"]');
    if (socialListEl) {
      socialListEl.innerHTML = socialItems
        .map(
          item =>
            `<a href="${item.link ||
              ''}" data-attribute="item-social" class="item-social"><img data-attribute="icon-social" src="${item.icon ||
              ''}" /></a>`,
        )
        .join('');
    }

    const orderTitleEl = container.querySelector('[data-attribute="title-column-order"]');
    if (orderTitleEl) orderTitleEl.textContent = updatedData.orderTitle || '';

    const orderItems = Array.isArray(updatedData.orderItems) ? updatedData.orderItems : [];
    const orderListEl = container.querySelector('[data-attribute="list-item-order"]');
    if (orderListEl) {
      orderListEl.innerHTML = orderItems
        .map(
          item => `<a href="${item.link || ''}" data-attribute="item-order" class="item-child">${item.text || ''}</a>`,
        )
        .join('');
    }

    const resourcesTitleEl = container.querySelector('[data-attribute="title-column-resources"]');
    if (resourcesTitleEl) resourcesTitleEl.textContent = updatedData.resourcesTitle || '';

    const resourcesItems = Array.isArray(updatedData.resourcesItems) ? updatedData.resourcesItems : [];
    const resourcesListEl = container.querySelector('[data-attribute="list-item-resources"]');
    if (resourcesListEl) {
      resourcesListEl.innerHTML = resourcesItems
        .map(
          item =>
            `<a href="${item.link || ''}" data-attribute="item-resources" class="item-child">${item.text || ''}</a>`,
        )
        .join('');
    }

    const subscribeTitleEl = container.querySelector('[data-attribute="title-column-subscribe"]');
    if (subscribeTitleEl) subscribeTitleEl.textContent = updatedData.subscribeTitle || '';

    const inputEl = container.querySelector('[data-attribute="input-email"]');
    if (inputEl) {
      const inputColor = updatedData.inputColor || '#AD4870';
      inputEl.setAttribute('placeholder', updatedData.inputPlaceholder || '');
      inputEl.setAttribute('data-color-input', inputColor);
      inputEl.style.setProperty('--color-input', inputColor);
    }

    const submitIconEl = container.querySelector('[data-attribute="icon-submit-email"]');
    if (submitIconEl) submitIconEl.setAttribute('src', updatedData.submitIcon || '');

    const descriptionEl = container.querySelector('[data-attribute="description-subscribe"]');
    if (descriptionEl) descriptionEl.textContent = updatedData.descriptionSubscribe || '';

    const bottomFooterEl = container.querySelector('[data-attribute="bottom-footer"]');
    if (bottomFooterEl) {
      const bg = updatedData.bottomBgColor || '#AD4870';
      const color = updatedData.bottomTextColor || '#FFFFFF';
      bottomFooterEl.setAttribute('data-bg-bottom-footer', bg);
      bottomFooterEl.setAttribute('data-color-bottom-footer', color);
      bottomFooterEl.style.setProperty('--bg-bottom-footer', bg);
      bottomFooterEl.style.setProperty('--color-bottom-footer', color);
    }

    const copyrightEl = container.querySelector('[data-attribute="copyright"]');
    if (copyrightEl) copyrightEl.textContent = updatedData.copyrightText || '';

    const paymentIconEl = container.querySelector('[data-attribute="payment-icon"]');
    if (paymentIconEl) paymentIconEl.setAttribute('src', updatedData.paymentIcon || '');

    return container.innerHTML.trim();
  },
  sectionCeflorecoBanner1(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const titleEl = container.querySelector('[data-attribute="title-banner"]');
    if (titleEl) {
      titleEl.innerHTML = updatedData.content || '';
    }

    const wrapImageEl = container.querySelector('[data-attribute="wrap-banner-image"]');
    if (wrapImageEl) {
      wrapImageEl.setAttribute('data-use-banner-mobile', updatedData.useBannerMobile !== false ? 'true' : 'false');
    }

    const imageDesktopEl = container.querySelector('[data-attribute="banner-image-desktop"]');
    if (imageDesktopEl) {
      imageDesktopEl.setAttribute('src', updatedData.imageDesktop || '');
    }

    const imageMobileEl = container.querySelector('[data-attribute="banner-image-mobile"]');
    if (imageMobileEl) {
      imageMobileEl.setAttribute('src', updatedData.imageMobile || '');
    }

    return container.innerHTML.trim();
  },
  sectionCeflorecoProductWorld(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const titleEl = container.querySelector('[data-attribute="title-card"]');
    if (titleEl) {
      titleEl.innerHTML = updatedData.titleContent || '';
    }

    const descEl = container.querySelector('[data-attribute="desc-card"]');
    if (descEl) {
      descEl.innerHTML = updatedData.descContent || '';
    }

    const imageEl = container.querySelector('[data-attribute="img-preview-image"]');
    if (imageEl) {
      imageEl.setAttribute('src', updatedData.image || '');
    }

    const listEl = container.querySelector('[data-attribute="list-fetures"]');
    if (listEl) {
      const colorBorderItem = updatedData.colorBorderItem || '#bebebe';
      const colorHighlightItem = updatedData.colorHighlightItem || '#ff7657';
      listEl.setAttribute('data-color-border-item', colorBorderItem);
      listEl.setAttribute('data-color-highlight-item', colorHighlightItem);
      listEl.style.setProperty('--color-border-item', colorBorderItem);
      listEl.style.setProperty('--color-highlight-item', colorHighlightItem);
      listEl.innerHTML = (updatedData.items || [])
        .map(
          item => `
    <div class="item-feture" data-attribute="item-freture">
      <div class="stt-item" data-attribute="stt-item">${item.number || ''}</div>
      <div class="content-item" data-attribute="content-item">${item.content || ''}</div>
    </div>`,
        )
        .join('');
    }

    return container.innerHTML.trim();
  },
  sectionCeflorecoBanner2(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const titleEl = container.querySelector('[data-attribute="title-card"]');
    if (titleEl) {
      titleEl.innerHTML = updatedData.titleContent || '';
    }

    const descEl = container.querySelector('[data-attribute="desc-card"]');
    if (descEl) {
      descEl.innerHTML = updatedData.descContent || '';
    }

    const imageEl = container.querySelector('[data-attribute="banner-image"]');
    if (imageEl) {
      imageEl.setAttribute('src', updatedData.image || '');
    }

    return container.innerHTML.trim();
  },
  sectionCeflorecoTextGradient(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const titleEl = container.querySelector('[data-attribute="title-gradient"]');
    if (titleEl) {
      const fromColor = updatedData.fromColor || '#eeeeee';
      const toColor = updatedData.toColor || '#333333';
      titleEl.textContent = updatedData.text || '';
      titleEl.setAttribute('data-from-color', fromColor);
      titleEl.setAttribute('data-to-color', toColor);
      titleEl.style.setProperty('--from-color', fromColor);
      titleEl.style.setProperty('--to-color', toColor);
    }

    const descEl = container.querySelector('[data-attribute="description"]');
    if (descEl) {
      descEl.textContent = updatedData.description || '';
    }

    return container.innerHTML.trim();
  },
  sectionCeflorecoSideBySide(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const imageEl = container.querySelector('[data-attribute="media-image"]');
    if (imageEl) {
      imageEl.setAttribute('src', updatedData.image || '');
    }

    const isMediaRight = updatedData.mediaPosition === 'right';
    const orderMedia = isMediaRight ? 2 : 1;
    const orderText = isMediaRight ? 1 : 2;

    const mediaEl = container.querySelector('[data-attribute="media-content"]');
    if (mediaEl) {
      mediaEl.setAttribute('data-order-media', String(orderMedia));
      mediaEl.style.setProperty('--order-media', String(orderMedia));
    }

    const textEl = container.querySelector('[data-attribute="text-content"]');
    if (textEl) {
      textEl.setAttribute('data-order-text', String(orderText));
      textEl.style.setProperty('--order-text', String(orderText));
      textEl.innerHTML = updatedData.content || '';
    }

    return container.innerHTML.trim();
  },
  sectionCeflorecoMobileApp(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const titleEl = container.querySelector('[data-attribute="title-card"]');
    if (titleEl) {
      titleEl.innerHTML = updatedData.content || '';
    }

    const imageEl = container.querySelector('[data-attribute="image"]');
    if (imageEl) {
      imageEl.setAttribute('src', updatedData.image || '');
    }

    return container.innerHTML.trim();
  },
  sectionCeflorecoBenefis(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const isMediaRight = updatedData.mediaPosition === 'right';
    const orderMedia = isMediaRight ? 2 : 1;
    const orderText = isMediaRight ? 1 : 2;

    const mediaEl = container.querySelector('[data-attribute="media-content"]');
    if (mediaEl) {
      const bgMediaTitle = updatedData.bgMediaTitle || '#1099dc';
      mediaEl.setAttribute('data-order-media', String(orderMedia));
      mediaEl.setAttribute('data-bg-media-title', bgMediaTitle);
      mediaEl.style.setProperty('--order-media', String(orderMedia));
      mediaEl.style.setProperty('--bg-media-title', bgMediaTitle);
    }

    const imageEl = container.querySelector('[data-attribute="media-image"]');
    if (imageEl) {
      imageEl.setAttribute('src', updatedData.image || '');
    }

    const mediaTitleEl = container.querySelector('[data-attribute="media-title"]');
    if (mediaTitleEl) {
      mediaTitleEl.innerHTML = updatedData.mediaTitle || '';
    }

    const textEl = container.querySelector('[data-attribute="text-content"]');
    if (textEl) {
      textEl.setAttribute('data-order-text', String(orderText));
      textEl.style.setProperty('--order-text', String(orderText));
    }

    const titleEl = container.querySelector('[data-attribute="title-content"]');
    if (titleEl) {
      titleEl.innerHTML = updatedData.titleContent || '';
    }

    const listEl = container.querySelector('[data-attribute="list-benefit"]');
    if (listEl) {
      const colorHighlightItem = updatedData.colorHighlightItem || '#ff7657';
      listEl.setAttribute('data-color-highlight-item', colorHighlightItem);
      listEl.style.setProperty('--color-highlight-item', colorHighlightItem);
      listEl.innerHTML = (updatedData.items || [])
        .map(
          item => `
        <div class="item-benefit" data-attribute="item-benefit">
          <div class="index-number" data-attribute="index-number">${item.number || ''}</div>
          <div class="content-benefit" data-attribute="content-benefit">${item.content || ''}</div>
        </div>`,
        )
        .join('');
    }

    return container.innerHTML.trim();
  },
  sectionCeflorecoLetsTalk(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const titleEl = container.querySelector('[data-attribute="title-section"]');
    if (titleEl) {
      titleEl.innerHTML = updatedData.titleContent || '';
    }

    const listEl = container.querySelector('[data-attribute="list-fetures"]');
    if (listEl) {
      const colorBorderItem = updatedData.colorBorderItem || '#bebebe';
      const colorHighlightItem = updatedData.colorHighlightItem || '#ff7657';
      listEl.setAttribute('data-color-border-item', colorBorderItem);
      listEl.setAttribute('data-color-highlight-item', colorHighlightItem);
      listEl.style.setProperty('--color-border-item', colorBorderItem);
      listEl.style.setProperty('--color-highlight-item', colorHighlightItem);
      listEl.innerHTML = (updatedData.items || [])
        .map(
          item => `
      <div class="item-feture" data-attribute="item-freture">
        <div class="stt-item" data-attribute="stt-item">${item.number || ''}</div>
        <div class="content-item" data-attribute="content-item">${item.content || ''}</div>
      </div>`,
        )
        .join('');
    }

    const bannerEl = container.querySelector('[data-attribute="banner-image"]');
    if (bannerEl) {
      bannerEl.setAttribute('href', updatedData.link || '#');
      bannerEl.setAttribute('data-use-banner-mobile', updatedData.useBannerMobile !== false ? 'true' : 'false');
    }

    const imageDesktopEl = container.querySelector('[data-attribute="banner-desktop"]');
    if (imageDesktopEl) {
      imageDesktopEl.setAttribute('src', updatedData.imageDesktop || '');
    }

    const imageMobileEl = container.querySelector('[data-attribute="banner-mobile"]');
    if (imageMobileEl) {
      imageMobileEl.setAttribute('src', updatedData.imageMobile || '');
    }

    return container.innerHTML.trim();
  },
  sectionCeflorecoFooter(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const logoEl = container.querySelector('[data-attribute="logo-image"]');
    if (logoEl) {
      logoEl.setAttribute('src', updatedData.logo || '');
    }

    const descEl = container.querySelector('[data-attribute="desc-company"]');
    if (descEl) {
      descEl.textContent = updatedData.description || '';
    }

    (updatedData.columns || []).forEach(column => {
      const titleEl = container.querySelector(`[data-attribute="title-column-${column.key}"]`);
      if (titleEl) {
        titleEl.textContent = column.title || '';
      }
      const listEl = container.querySelector(`[data-attribute="list-item-${column.key}"]`);
      if (listEl) {
        listEl.innerHTML = '';
        (column.items || []).forEach(item => {
          const linkEl = container.ownerDocument.createElement('a');
          linkEl.setAttribute('href', item.url || '');
          linkEl.setAttribute('data-attribute', 'item-child');
          linkEl.setAttribute('class', 'item-child');
          linkEl.textContent = item.label || '';
          listEl.appendChild(linkEl);
        });
      }
    });

    const contactTitleEl = container.querySelector('[data-attribute="title-column-contact"]');
    if (contactTitleEl) {
      contactTitleEl.textContent = updatedData.contactTitle || '';
    }
    container.querySelectorAll('[data-attribute="contact-item"]').forEach((item, index) => {
      const data = (updatedData.contactItems || [])[index];
      if (!data) return;
      const labelEl = item.querySelector('[data-attribute="contact-label"]');
      const linkEl = item.querySelector('[data-attribute="contact-link"]');
      if (labelEl) labelEl.textContent = data.label || '';
      if (linkEl) {
        linkEl.textContent = data.text || '';
        linkEl.setAttribute('href', data.url || '');
      }
    });

    const copyrightEl = container.querySelector('[data-attribute="copyright"]');
    if (copyrightEl) {
      copyrightEl.textContent = updatedData.copyright || '';
    }

    return container.innerHTML.trim();
  },
};
